//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const AUTHORIZATION_API_BASE_URL = new InjectionToken<string>('AUTHORIZATION_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AuthorizationFunctionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(AUTHORIZATION_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAgreementHistoryByAcn(authAgreementNumber: string): Observable<BudgetSummaryHistoryGridResponseBase> {
        let url_ = this.baseUrl + "/api/Auth/{authAgreementNumber}/history";
        if (authAgreementNumber === undefined || authAgreementNumber === null)
            throw new Error("The parameter 'authAgreementNumber' must be defined.");
        url_ = url_.replace("{authAgreementNumber}", encodeURIComponent("" + authAgreementNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgreementHistoryByAcn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgreementHistoryByAcn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BudgetSummaryHistoryGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BudgetSummaryHistoryGridResponseBase>;
        }));
    }

    protected processGetAgreementHistoryByAcn(response: HttpResponseBase): Observable<BudgetSummaryHistoryGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetSummaryHistoryGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRefreshAuth(adjustCCNOption: number, body?: PostRequestRefreshAuth | undefined): Observable<RefreshResponseDto[]> {
        let url_ = this.baseUrl + "/api/Auth/adjustType/{adjustCCNOption}";
        if (adjustCCNOption === undefined || adjustCCNOption === null)
            throw new Error("The parameter 'adjustCCNOption' must be defined.");
        url_ = url_.replace("{adjustCCNOption}", encodeURIComponent("" + adjustCCNOption));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRefreshAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRefreshAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshResponseDto[]>;
        }));
    }

    protected processGetRefreshAuth(response: HttpResponseBase): Observable<RefreshResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefreshResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteAuthorization(id: number): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/Auth/agreement/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAuthorization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteAuthorization(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAgreementDetailsTransaction(body?: AuthDetailsTransactionRequest | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Auth/agreement/details/transaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgreementDetailsTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgreementDetailsTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAgreementDetailsTransaction(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAgreementDetailsTransactionCoverage(body?: AuthDetailsTransactionRequest | undefined): Observable<AgreementDetailsTransactionResponse[]> {
        let url_ = this.baseUrl + "/api/Auth/agreement/details/transactioncoverage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgreementDetailsTransactionCoverage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgreementDetailsTransactionCoverage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementDetailsTransactionResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementDetailsTransactionResponse[]>;
        }));
    }

    protected processGetAgreementDetailsTransactionCoverage(response: HttpResponseBase): Observable<AgreementDetailsTransactionResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgreementDetailsTransactionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDiagnosisCode(code: string): Observable<AgreementDiagnosisCodeResponseApiResponse> {
        let url_ = this.baseUrl + "/api/Auth/agreement/diagcode/{code}/fetch";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiagnosisCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiagnosisCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementDiagnosisCodeResponseApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementDiagnosisCodeResponseApiResponse>;
        }));
    }

    protected processGetDiagnosisCode(response: HttpResponseBase): Observable<AgreementDiagnosisCodeResponseApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementDiagnosisCodeResponseApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAuthorizationExpiry(body?: AuthorizationExpiryRequest | undefined): Observable<AuthorizationExpiryResponse[]> {
        let url_ = this.baseUrl + "/api/Auth/agreement/expiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizationExpiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizationExpiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizationExpiryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizationExpiryResponse[]>;
        }));
    }

    protected processGetAuthorizationExpiry(response: HttpResponseBase): Observable<AuthorizationExpiryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorizationExpiryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAgreement(acn: string): Observable<AgreementHeader> {
        let url_ = this.baseUrl + "/api/Auth/agreement/header/{acn}/fetch";
        if (acn === undefined || acn === null)
            throw new Error("The parameter 'acn' must be defined.");
        url_ = url_.replace("{acn}", encodeURIComponent("" + acn));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgreement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementHeader>;
        }));
    }

    protected processGetAgreement(response: HttpResponseBase): Observable<AgreementHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    isTransactionLogExistsForAgreement(agreeNumber: string, participantId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Auth/agreement/header/{agreeNumber}/{participantId}";
        if (agreeNumber === undefined || agreeNumber === null)
            throw new Error("The parameter 'agreeNumber' must be defined.");
        url_ = url_.replace("{agreeNumber}", encodeURIComponent("" + agreeNumber));
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTransactionLogExistsForAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTransactionLogExistsForAgreement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsTransactionLogExistsForAgreement(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAgreementHistory(body?: AgreementLogHeaderRequest | undefined): Observable<StringApiResponse> {
        let url_ = this.baseUrl + "/api/Auth/agreement/history/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAgreementHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAgreementHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringApiResponse>;
        }));
    }

    protected processExportAgreementHistory(response: HttpResponseBase): Observable<StringApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getInsuredId(body?: InsuredIdRequest | undefined): Observable<AgreementInsuredIdResponseIListApiResponse> {
        let url_ = this.baseUrl + "/api/Auth/agreement/insuredid/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsuredId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsuredId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementInsuredIdResponseIListApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementInsuredIdResponseIListApiResponse>;
        }));
    }

    protected processGetInsuredId(response: HttpResponseBase): Observable<AgreementInsuredIdResponseIListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementInsuredIdResponseIListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getParticipantInsuranceInfoHistory(participantId: number, insuranceRecordId: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/Auth/agreement/participant/{participantId}/history/{insuranceRecordId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        if (insuranceRecordId === undefined || insuranceRecordId === null)
            throw new Error("The parameter 'insuranceRecordId' must be defined.");
        url_ = url_.replace("{insuranceRecordId}", encodeURIComponent("" + insuranceRecordId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantInsuranceInfoHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantInsuranceInfoHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetParticipantInsuranceInfoHistory(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParticipant(personId: string): Observable<AgreementParticipantResponse> {
        let url_ = this.baseUrl + "/api/Auth/agreement/participant/{personId}/fetch";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementParticipantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementParticipantResponse>;
        }));
    }

    protected processGetParticipant(response: HttpResponseBase): Observable<AgreementParticipantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementParticipantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPrograms(): Observable<AgreementProgramsResponse[]> {
        let url_ = this.baseUrl + "/api/Auth/agreement/programs/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrograms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrograms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementProgramsResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementProgramsResponse[]>;
        }));
    }

    protected processGetPrograms(response: HttpResponseBase): Observable<AgreementProgramsResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgreementProgramsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveAgreement(body?: AgreementHeader | undefined): Observable<StringApiResponse> {
        let url_ = this.baseUrl + "/api/Auth/agreement/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAgreement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringApiResponse>;
        }));
    }

    protected processSaveAgreement(response: HttpResponseBase): Observable<StringApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getServiceAgreementStatus(): Observable<ServiceAgreementStatusResponse[]> {
        let url_ = this.baseUrl + "/api/Auth/agreement/service/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceAgreementStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceAgreementStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceAgreementStatusResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceAgreementStatusResponse[]>;
        }));
    }

    protected processGetServiceAgreementStatus(response: HttpResponseBase): Observable<ServiceAgreementStatusResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceAgreementStatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAuthorizationStart(body?: EventHarvestorRequest | undefined): Observable<AuthorizationStartResponse[]> {
        let url_ = this.baseUrl + "/api/Auth/agreement/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizationStart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizationStart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizationStartResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizationStartResponse[]>;
        }));
    }

    protected processGetAuthorizationStart(response: HttpResponseBase): Observable<AuthorizationStartResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorizationStartResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAgreementStatus(): Observable<AgreementStatusResponse[]> {
        let url_ = this.baseUrl + "/api/Auth/agreement/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgreementStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgreementStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementStatusResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementStatusResponse[]>;
        }));
    }

    protected processGetAgreementStatus(response: HttpResponseBase): Observable<AgreementStatusResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgreementStatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSubAccountHistory(body?: SubAccountHistoryRequest | undefined): Observable<SubAccountHistoryResponseGridResponseBase> {
        let url_ = this.baseUrl + "/api/Auth/agreement/subaccount/history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubAccountHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubAccountHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubAccountHistoryResponseGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubAccountHistoryResponseGridResponseBase>;
        }));
    }

    protected processGetSubAccountHistory(response: HttpResponseBase): Observable<SubAccountHistoryResponseGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubAccountHistoryResponseGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAgreement(body?: AgreementHeader | undefined): Observable<AgreementUpdateRepsonseApiResponse> {
        let url_ = this.baseUrl + "/api/Auth/agreement/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAgreement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementUpdateRepsonseApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementUpdateRepsonseApiResponse>;
        }));
    }

    protected processUpdateAgreement(response: HttpResponseBase): Observable<AgreementUpdateRepsonseApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementUpdateRepsonseApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAuthCodeByParticipant(body?: AuthCodeLkpByParticipantRequest | undefined): Observable<AuthCodeLkpByParticipantResponseGridResponseBase> {
        let url_ = this.baseUrl + "/api/Auth/authcode/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthCodeByParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthCodeByParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthCodeLkpByParticipantResponseGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthCodeLkpByParticipantResponseGridResponseBase>;
        }));
    }

    protected processGetAuthCodeByParticipant(response: HttpResponseBase): Observable<AuthCodeLkpByParticipantResponseGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthCodeLkpByParticipantResponseGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverShiftHours(body?: CaregiverShiftHoursRequest | undefined): Observable<CaregiverShiftHoursResponse> {
        let url_ = this.baseUrl + "/api/Auth/caregiver/hours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverShiftHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverShiftHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverShiftHoursResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverShiftHoursResponse>;
        }));
    }

    protected processGetCaregiverShiftHours(response: HttpResponseBase): Observable<CaregiverShiftHoursResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverShiftHoursResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverParticipantWeeklyUnits(body?: CaregiverWeeklyUnitsRequest | undefined): Observable<CaregiverWeeklyUnitsHolder> {
        let url_ = this.baseUrl + "/api/Auth/caregiver/participant/weeklyunits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantWeeklyUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantWeeklyUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverWeeklyUnitsHolder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverWeeklyUnitsHolder>;
        }));
    }

    protected processGetCaregiverParticipantWeeklyUnits(response: HttpResponseBase): Observable<CaregiverWeeklyUnitsHolder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverWeeklyUnitsHolder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverWeeklyHours(body?: CaregiverWeeklyHoursRequest | undefined): Observable<CaregiverWeeklyHoursResponse[]> {
        let url_ = this.baseUrl + "/api/Auth/caregiver/weeklyhours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverWeeklyHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverWeeklyHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverWeeklyHoursResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverWeeklyHoursResponse[]>;
        }));
    }

    protected processGetCaregiverWeeklyHours(response: HttpResponseBase): Observable<CaregiverWeeklyHoursResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverWeeklyHoursResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAuthDetailsByAuthExternalId(authExternalId: string): Observable<AuthHeaderDetails> {
        let url_ = this.baseUrl + "/api/Auth/details/fetch/{authExternalId}";
        if (authExternalId === undefined || authExternalId === null)
            throw new Error("The parameter 'authExternalId' must be defined.");
        url_ = url_.replace("{authExternalId}", encodeURIComponent("" + authExternalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthDetailsByAuthExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthDetailsByAuthExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthHeaderDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthHeaderDetails>;
        }));
    }

    protected processGetAuthDetailsByAuthExternalId(response: HttpResponseBase): Observable<AuthHeaderDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthHeaderDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveAuthEmployerLiability(body?: AuthTransactionRequest[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/Auth/employerliability/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAuthEmployerLiability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAuthEmployerLiability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSaveAuthEmployerLiability(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAuthDetails(body?: AuthorizationSearchRequest | undefined): Observable<AuthorizationGridResponseBase> {
        let url_ = this.baseUrl + "/api/Auth/fetch/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizationGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizationGridResponseBase>;
        }));
    }

    protected processGetAuthDetails(response: HttpResponseBase): Observable<AuthorizationGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizationGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAuthOwners(body?: AuthOwnersRequest | undefined): Observable<StringGridResponseBase> {
        let url_ = this.baseUrl + "/api/Auth/getAuthOwners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthOwners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthOwners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringGridResponseBase>;
        }));
    }

    protected processGetAuthOwners(response: HttpResponseBase): Observable<StringGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveInternalAuthTransactionLog(body?: AuthInternalTransactionRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Auth/internaltransaction/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveInternalAuthTransactionLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveInternalAuthTransactionLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveInternalAuthTransactionLog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllParticipants(body?: AuthorizationSearchRequest | undefined): Observable<AuthorizationGridResponseBase> {
        let url_ = this.baseUrl + "/api/Auth/participants/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParticipants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizationGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizationGridResponseBase>;
        }));
    }

    protected processGetAllParticipants(response: HttpResponseBase): Observable<AuthorizationGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizationGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPayperiod(body?: PayPeriodRequest | undefined): Observable<PayPeriodApiResponseApiResponse> {
        let url_ = this.baseUrl + "/api/Auth/payperiod/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayperiod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayperiod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayPeriodApiResponseApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayPeriodApiResponseApiResponse>;
        }));
    }

    protected processGetPayperiod(response: HttpResponseBase): Observable<PayPeriodApiResponseApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayPeriodApiResponseApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(body?: ServiceAgreementSaveRequest | undefined): Observable<StringApiResponse> {
        let url_ = this.baseUrl + "/api/Auth/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringApiResponse>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<StringApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAuthServiceDetails(body?: AgreementLogHeaderRequest | undefined): Observable<StringApiResponse> {
        let url_ = this.baseUrl + "/api/Auth/service/details/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAuthServiceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAuthServiceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringApiResponse>;
        }));
    }

    protected processExportAuthServiceDetails(response: HttpResponseBase): Observable<StringApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCurrentAuthServiceUtilization(body?: CurrentAuthorizationServiceUtilization | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Auth/servicecode/CurrentServiceUtilization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentAuthServiceUtilization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentAuthServiceUtilization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCurrentAuthServiceUtilization(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSeviceCodeDetails(serviceCode: string): Observable<ServiceCodeDetailsResponse> {
        let url_ = this.baseUrl + "/api/Auth/servicecode/details/{serviceCode}/fetch";
        if (serviceCode === undefined || serviceCode === null)
            throw new Error("The parameter 'serviceCode' must be defined.");
        url_ = url_.replace("{serviceCode}", encodeURIComponent("" + serviceCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeviceCodeDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeviceCodeDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCodeDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCodeDetailsResponse>;
        }));
    }

    protected processGetSeviceCodeDetails(response: HttpResponseBase): Observable<ServiceCodeDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCodeDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAuthSubUtilizationPeriods(): Observable<AuthorizationSubUtilizationPeriodsResponse[]> {
        let url_ = this.baseUrl + "/api/Auth/servicecode/SubUtilizationPeriods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthSubUtilizationPeriods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthSubUtilizationPeriods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizationSubUtilizationPeriodsResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizationSubUtilizationPeriodsResponse[]>;
        }));
    }

    protected processGetAuthSubUtilizationPeriods(response: HttpResponseBase): Observable<AuthorizationSubUtilizationPeriodsResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorizationSubUtilizationPeriodsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertServiceCodeUsageLimit(body?: ServiceCodeUsageLimitDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/Auth/servicecode/UpsertServiceCodeUsageLimit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertServiceCodeUsageLimit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertServiceCodeUsageLimit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpsertServiceCodeUsageLimit(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSnapshotSummaryDetails(personId: string): Observable<AuthDetailSnapshotSummaryResponse[]> {
        let url_ = this.baseUrl + "/api/Auth/snapshot/fetch/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSnapshotSummaryDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSnapshotSummaryDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthDetailSnapshotSummaryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthDetailSnapshotSummaryResponse[]>;
        }));
    }

    protected processGetSnapshotSummaryDetails(response: HttpResponseBase): Observable<AuthDetailSnapshotSummaryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthDetailSnapshotSummaryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getServiceSummaryDetails(body?: AuthDetailSummaryRequest | undefined): Observable<AuthDetailSummaryResponse> {
        let url_ = this.baseUrl + "/api/Auth/summary/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceSummaryDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceSummaryDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthDetailSummaryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthDetailSummaryResponse>;
        }));
    }

    protected processGetServiceSummaryDetails(response: HttpResponseBase): Observable<AuthDetailSummaryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthDetailSummaryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAuthTransactionLog(body?: PayrollPaidTransactionResult[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Auth/transaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAuthTransactionLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAuthTransactionLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAuthTransactionLog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveAuthTransactionLog(body?: AuthTransactionRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Auth/transaction/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAuthTransactionLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAuthTransactionLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveAuthTransactionLog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUtilizationSummaryByAuthDetailId(body?: number | undefined): Observable<UtilizationSummary[]> {
        let url_ = this.baseUrl + "/api/Auth/utilizationsummary/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilizationSummaryByAuthDetailId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilizationSummaryByAuthDetailId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UtilizationSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UtilizationSummary[]>;
        }));
    }

    protected processGetUtilizationSummaryByAuthDetailId(response: HttpResponseBase): Observable<UtilizationSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UtilizationSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveAuthAllocationDetails(body?: AuthAllocationRequest | undefined): Observable<BooleanApiResponse> {
        let url_ = this.baseUrl + "/api/AuthAllocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAuthAllocationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAuthAllocationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanApiResponse>;
        }));
    }

    protected processSaveAuthAllocationDetails(response: HttpResponseBase): Observable<BooleanApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param caregiverPersonId (optional) 
     * @return Success
     */
    getAllAuthAllocations(participantPersonId: string, startDate?: string | undefined, endDate?: string | undefined, caregiverPersonId?: string | undefined): Observable<AuthAllocationDetail> {
        let url_ = this.baseUrl + "/api/AuthAllocation/{participantPersonId}?";
        if (participantPersonId === undefined || participantPersonId === null)
            throw new Error("The parameter 'participantPersonId' must be defined.");
        url_ = url_.replace("{participantPersonId}", encodeURIComponent("" + participantPersonId));
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (caregiverPersonId === null)
            throw new Error("The parameter 'caregiverPersonId' cannot be null.");
        else if (caregiverPersonId !== undefined)
            url_ += "caregiverPersonId=" + encodeURIComponent("" + caregiverPersonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAuthAllocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAuthAllocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthAllocationDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthAllocationDetail>;
        }));
    }

    protected processGetAllAuthAllocations(response: HttpResponseBase): Observable<AuthAllocationDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthAllocationDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAuthLegend(body?: ServCodeLegendRequest | undefined): Observable<ServCodeLegendResponse[]> {
        let url_ = this.baseUrl + "/api/AuthAllocation/authLegendData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthLegend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthLegend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServCodeLegendResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServCodeLegendResponse[]>;
        }));
    }

    protected processGetAuthLegend(response: HttpResponseBase): Observable<ServCodeLegendResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServCodeLegendResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    autoAllocatePtCgs(body?: AutoAuthAllocationRequest | undefined): Observable<CaregiverParticipantAuthAllocationDetail[]> {
        let url_ = this.baseUrl + "/api/AuthAllocation/autoallocateptcgs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAutoAllocatePtCgs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutoAllocatePtCgs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverParticipantAuthAllocationDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverParticipantAuthAllocationDetail[]>;
        }));
    }

    protected processAutoAllocatePtCgs(response: HttpResponseBase): Observable<CaregiverParticipantAuthAllocationDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverParticipantAuthAllocationDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverParticipantAuthAllocationDetails(body?: CaregiverWeeklyAllocationsRequest | undefined): Observable<CaregiverParticipantAuthAllocationDetail[]> {
        let url_ = this.baseUrl + "/api/AuthAllocation/caregiver-participant/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantAuthAllocationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantAuthAllocationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverParticipantAuthAllocationDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverParticipantAuthAllocationDetail[]>;
        }));
    }

    protected processGetCaregiverParticipantAuthAllocationDetails(response: HttpResponseBase): Observable<CaregiverParticipantAuthAllocationDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverParticipantAuthAllocationDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCareGiverWeeklyAllocation(body?: CaregiverWeeklyAllocationsRequest | undefined): Observable<CaregiverWeeklyAllocationsResponse[]> {
        let url_ = this.baseUrl + "/api/AuthAllocation/caregiver/weeklyAllocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareGiverWeeklyAllocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareGiverWeeklyAllocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverWeeklyAllocationsResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverWeeklyAllocationsResponse[]>;
        }));
    }

    protected processGetCareGiverWeeklyAllocation(response: HttpResponseBase): Observable<CaregiverWeeklyAllocationsResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverWeeklyAllocationsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAuthAllocationExpiry(body?: AuthAllocationsExpiryRequest | undefined): Observable<AuthAllocationsExpiryResponse[]> {
        let url_ = this.baseUrl + "/api/AuthAllocation/expiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthAllocationExpiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthAllocationExpiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthAllocationsExpiryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthAllocationsExpiryResponse[]>;
        }));
    }

    protected processGetAuthAllocationExpiry(response: HttpResponseBase): Observable<AuthAllocationsExpiryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthAllocationsExpiryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    authAllocationStatus(participantPersonId: string, startDate?: string | undefined, endDate?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/AuthAllocation/status/{participantPersonId}?";
        if (participantPersonId === undefined || participantPersonId === null)
            throw new Error("The parameter 'participantPersonId' must be defined.");
        url_ = url_.replace("{participantPersonId}", encodeURIComponent("" + participantPersonId));
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthAllocationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthAllocationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAuthAllocationStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteInternalAuthorizations(body?: InternalAuthorizationsDeleteDto | undefined): Observable<InternalAuthorizationsDeleteDto> {
        let url_ = this.baseUrl + "/api/Authorization/internal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInternalAuthorizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInternalAuthorizations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalAuthorizationsDeleteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalAuthorizationsDeleteDto>;
        }));
    }

    protected processDeleteInternalAuthorizations(response: HttpResponseBase): Observable<InternalAuthorizationsDeleteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalAuthorizationsDeleteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllInternalAuthorization(caregiverId: number, employerId: number): Observable<InternalAuthorizationResponseList> {
        let url_ = this.baseUrl + "/api/Authorization/internal/{caregiverId}/{employerId}";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (employerId === undefined || employerId === null)
            throw new Error("The parameter 'employerId' must be defined.");
        url_ = url_.replace("{employerId}", encodeURIComponent("" + employerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInternalAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInternalAuthorization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalAuthorizationResponseList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalAuthorizationResponseList>;
        }));
    }

    protected processGetAllInternalAuthorization(response: HttpResponseBase): Observable<InternalAuthorizationResponseList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalAuthorizationResponseList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getInternalAuthLedger(caregiverId: number, employerId: number, serviceCode: string, pageNum: number, pageSize: number, sortDesc: boolean, startDate?: string | undefined, endDate?: string | undefined): Observable<AuthLedgerTransactionHolder> {
        let url_ = this.baseUrl + "/api/Authorization/internal/{caregiverId}/{employerId}/{serviceCode}/{pageNum}/{pageSize}/{sortDesc}/ledger?";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (employerId === undefined || employerId === null)
            throw new Error("The parameter 'employerId' must be defined.");
        url_ = url_.replace("{employerId}", encodeURIComponent("" + employerId));
        if (serviceCode === undefined || serviceCode === null)
            throw new Error("The parameter 'serviceCode' must be defined.");
        url_ = url_.replace("{serviceCode}", encodeURIComponent("" + serviceCode));
        if (pageNum === undefined || pageNum === null)
            throw new Error("The parameter 'pageNum' must be defined.");
        url_ = url_.replace("{pageNum}", encodeURIComponent("" + pageNum));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        if (sortDesc === undefined || sortDesc === null)
            throw new Error("The parameter 'sortDesc' must be defined.");
        url_ = url_.replace("{sortDesc}", encodeURIComponent("" + sortDesc));
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalAuthLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalAuthLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthLedgerTransactionHolder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthLedgerTransactionHolder>;
        }));
    }

    protected processGetInternalAuthLedger(response: HttpResponseBase): Observable<AuthLedgerTransactionHolder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthLedgerTransactionHolder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCurrentInternalAuthServiceUtilization(body?: CurrentAuthorizationServiceUtilization | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Authorization/internal/CurrentInternalAuthServiceUtilization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentInternalAuthServiceUtilization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentInternalAuthServiceUtilization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCurrentInternalAuthServiceUtilization(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertInternalAuthorization(body?: InternalAuthorizationRequestList | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Authorization/internal/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertInternalAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertInternalAuthorization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpsertInternalAuthorization(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverServiceCode(body?: ServiceCodeRequest | undefined): Observable<ServiceCodeListResponse> {
        let url_ = this.baseUrl + "/api/Authorization/internal/servicecode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverServiceCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverServiceCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCodeListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCodeListResponse>;
        }));
    }

    protected processGetCaregiverServiceCode(response: HttpResponseBase): Observable<ServiceCodeListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCodeListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getInternalAuthUnits(body?: InternalAuthorizationUnitsRequest | undefined): Observable<InternalAuthorizationUnitsResponse[]> {
        let url_ = this.baseUrl + "/api/Authorization/internal/Units";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalAuthUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalAuthUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalAuthorizationUnitsResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalAuthorizationUnitsResponse[]>;
        }));
    }

    protected processGetInternalAuthUnits(response: HttpResponseBase): Observable<InternalAuthorizationUnitsResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InternalAuthorizationUnitsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportInternalAuthorizationLedger(body?: InternalAuthLedgerRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/Authorization/internalledger/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportInternalAuthorizationLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportInternalAuthorizationLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportInternalAuthorizationLedger(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBcnServicedetails(body?: BillingRecordsRequestDto | undefined): Observable<BillingRecordsResponseDto[]> {
        let url_ = this.baseUrl + "/api/BcnServiceDetails/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBcnServicedetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBcnServicedetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingRecordsResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingRecordsResponseDto[]>;
        }));
    }

    protected processGetBcnServicedetails(response: HttpResponseBase): Observable<BillingRecordsResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillingRecordsResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caregiverIdQuery (optional) 
     * @param employerIdQuery (optional) 
     * @return Success
     */
    getCareGiverPtoUnitsByEmployer(caregiverIdPath: string, employerIdPath: string, caregiverIdQuery?: string | undefined, employerIdQuery?: string | undefined): Observable<CareGiverPtoDetails> {
        let url_ = this.baseUrl + "/api/Caregiver/{caregiverId}/{employerId}/pto?";
        if (caregiverIdPath === undefined || caregiverIdPath === null)
            throw new Error("The parameter 'caregiverIdPath' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverIdPath));
        if (employerIdPath === undefined || employerIdPath === null)
            throw new Error("The parameter 'employerIdPath' must be defined.");
        url_ = url_.replace("{employerId}", encodeURIComponent("" + employerIdPath));
        if (caregiverIdQuery === null)
            throw new Error("The parameter 'caregiverIdQuery' cannot be null.");
        else if (caregiverIdQuery !== undefined)
            url_ += "caregiverId=" + encodeURIComponent("" + caregiverIdQuery) + "&";
        if (employerIdQuery === null)
            throw new Error("The parameter 'employerIdQuery' cannot be null.");
        else if (employerIdQuery !== undefined)
            url_ += "employerId=" + encodeURIComponent("" + employerIdQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareGiverPtoUnitsByEmployer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareGiverPtoUnitsByEmployer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareGiverPtoDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareGiverPtoDetails>;
        }));
    }

    protected processGetCareGiverPtoUnitsByEmployer(response: HttpResponseBase): Observable<CareGiverPtoDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareGiverPtoDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caregiverIdQuery (optional) 
     * @return Success
     */
    getCareGiverPtoUnits(caregiverIdPath: string, caregiverIdQuery?: string | undefined): Observable<CareGiverPtoDetails> {
        let url_ = this.baseUrl + "/api/Caregiver/{caregiverId}/pto?";
        if (caregiverIdPath === undefined || caregiverIdPath === null)
            throw new Error("The parameter 'caregiverIdPath' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverIdPath));
        if (caregiverIdQuery === null)
            throw new Error("The parameter 'caregiverIdQuery' cannot be null.");
        else if (caregiverIdQuery !== undefined)
            url_ += "caregiverId=" + encodeURIComponent("" + caregiverIdQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareGiverPtoUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareGiverPtoUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareGiverPtoDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareGiverPtoDetails>;
        }));
    }

    protected processGetCareGiverPtoUnits(response: HttpResponseBase): Observable<CareGiverPtoDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareGiverPtoDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caregiverIdQuery (optional) 
     * @param employerIdQuery (optional) 
     * @return Success
     */
    getInternalAuthorizationBalances(caregiverIdPath: string, employerIdPath: string, caregiverIdQuery?: string | undefined, employerIdQuery?: string | undefined): Observable<InternalAuthorizationBalancesDetail[]> {
        let url_ = this.baseUrl + "/api/InternalAuthorization/{caregiverId}/{employerId}/balances?";
        if (caregiverIdPath === undefined || caregiverIdPath === null)
            throw new Error("The parameter 'caregiverIdPath' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverIdPath));
        if (employerIdPath === undefined || employerIdPath === null)
            throw new Error("The parameter 'employerIdPath' must be defined.");
        url_ = url_.replace("{employerId}", encodeURIComponent("" + employerIdPath));
        if (caregiverIdQuery === null)
            throw new Error("The parameter 'caregiverIdQuery' cannot be null.");
        else if (caregiverIdQuery !== undefined)
            url_ += "caregiverId=" + encodeURIComponent("" + caregiverIdQuery) + "&";
        if (employerIdQuery === null)
            throw new Error("The parameter 'employerIdQuery' cannot be null.");
        else if (employerIdQuery !== undefined)
            url_ += "employerId=" + encodeURIComponent("" + employerIdQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalAuthorizationBalances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalAuthorizationBalances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalAuthorizationBalancesDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalAuthorizationBalancesDetail[]>;
        }));
    }

    protected processGetInternalAuthorizationBalances(response: HttpResponseBase): Observable<InternalAuthorizationBalancesDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InternalAuthorizationBalancesDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getServiceCodeUnitRange(body?: ServiceCodeUnitRangeRequest | undefined): Observable<ServiceCodeUnitRangeDto[]> {
        let url_ = this.baseUrl + "/api/InternalAuthorization/unitrange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCodeUnitRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCodeUnitRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCodeUnitRangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCodeUnitRangeDto[]>;
        }));
    }

    protected processGetServiceCodeUnitRange(response: HttpResponseBase): Observable<ServiceCodeUnitRangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCodeUnitRangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertServiceCodeUnitRange(body?: ServiceCodeUnitRangeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/InternalAuthorization/unitrange/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertServiceCodeUnitRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertServiceCodeUnitRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpsertServiceCodeUnitRange(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParticipantAuthDetails(participantId: number): Observable<ParticipantAuthResponse> {
        let url_ = this.baseUrl + "/api/Participant/{participantId}/auth/fetch";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantAuthDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantAuthDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantAuthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantAuthResponse>;
        }));
    }

    protected processGetParticipantAuthDetails(response: HttpResponseBase): Observable<ParticipantAuthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantAuthResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getServCodeOwners(body?: ServCodeOwnerRequest | undefined): Observable<StringGridResponseBase> {
        let url_ = this.baseUrl + "/api/Servcode/getServcodeOwners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServCodeOwners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServCodeOwners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringGridResponseBase>;
        }));
    }

    protected processGetServCodeOwners(response: HttpResponseBase): Observable<StringGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllWaiverCodes(): Observable<WaiverCodeDetails[]> {
        let url_ = this.baseUrl + "/api/WaiverCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWaiverCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWaiverCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaiverCodeDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaiverCodeDetails[]>;
        }));
    }

    protected processGetAllWaiverCodes(response: HttpResponseBase): Observable<WaiverCodeDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WaiverCodeDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getWaiverCodesByServiceCodeId(serviceCodeId: number): Observable<WaiverCodeDetails[]> {
        let url_ = this.baseUrl + "/api/WaiverCodes/getWaiverCodesByServiceCodeId/{serviceCodeId}";
        if (serviceCodeId === undefined || serviceCodeId === null)
            throw new Error("The parameter 'serviceCodeId' must be defined.");
        url_ = url_.replace("{serviceCodeId}", encodeURIComponent("" + serviceCodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaiverCodesByServiceCodeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaiverCodesByServiceCodeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaiverCodeDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaiverCodeDetails[]>;
        }));
    }

    protected processGetWaiverCodesByServiceCodeId(response: HttpResponseBase): Observable<WaiverCodeDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WaiverCodeDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AgreementDetailsTransactionResponse implements IAgreementDetailsTransactionResponse {
    txId?: string | undefined;
    servDate?: Date | undefined;

    constructor(data?: IAgreementDetailsTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.txId = _data["txId"];
            this.servDate = _data["servDate"] ? new Date(_data["servDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgreementDetailsTransactionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementDetailsTransactionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["txId"] = this.txId;
        data["servDate"] = this.servDate ? this.servDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAgreementDetailsTransactionResponse {
    txId?: string | undefined;
    servDate?: Date | undefined;
}

export class AgreementDiagnosisCodeResponse implements IAgreementDiagnosisCodeResponse {
    id?: number;
    description?: string | undefined;
    code?: string | undefined;

    constructor(data?: IAgreementDiagnosisCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): AgreementDiagnosisCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementDiagnosisCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["code"] = this.code;
        return data;
    }
}

export interface IAgreementDiagnosisCodeResponse {
    id?: number;
    description?: string | undefined;
    code?: string | undefined;
}

export class AgreementDiagnosisCodeResponseApiResponse implements IAgreementDiagnosisCodeResponseApiResponse {
    message?: string | undefined;
    data?: AgreementDiagnosisCodeResponse;
    success?: boolean;

    constructor(data?: IAgreementDiagnosisCodeResponseApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.data = _data["data"] ? AgreementDiagnosisCodeResponse.fromJS(_data["data"]) : <any>undefined;
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): AgreementDiagnosisCodeResponseApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementDiagnosisCodeResponseApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["success"] = this.success;
        return data;
    }
}

export interface IAgreementDiagnosisCodeResponseApiResponse {
    message?: string | undefined;
    data?: AgreementDiagnosisCodeResponse;
    success?: boolean;
}

export class AgreementHeader implements IAgreementHeader {
    id?: number | undefined;
    programId?: number | undefined;
    programNumber?: string | undefined;
    companyCode?: string | undefined;
    companyId?: number;
    acn?: string | undefined;
    headerAuthExternalId?: string | undefined;
    diagId?: number | undefined;
    diagCode?: string | undefined;
    agreementNumber?: string | undefined;
    custId?: number | undefined;
    clientId?: string | undefined;
    clientName?: string | undefined;
    programType?: string | undefined;
    startDate?: Date | undefined;
    dob?: Date | undefined;
    endDate?: Date | undefined;
    subAccount?: string | undefined;
    status?: AuthHeaderStatus[] | undefined;
    budgetSummaries?: BudgetSummary[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    isDraft?: boolean;
    insuredId?: string | undefined;
    solomonId?: string | undefined;
    clientArea?: string | undefined;
    clientTerritory?: string | undefined;
    clientStatus?: string | undefined;
    transactionExist?: boolean;
    payorCode?: string | undefined;
    weekStartDay?: DayOfWeek;
    programCoordinatorId?: number | undefined;
    serviceId?: string | undefined;

    constructor(data?: IAgreementHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programId = _data["programId"];
            this.programNumber = _data["programNumber"];
            this.companyCode = _data["companyCode"];
            this.companyId = _data["companyId"];
            this.acn = _data["acn"];
            this.headerAuthExternalId = _data["headerAuthExternalId"];
            this.diagId = _data["diagId"];
            this.diagCode = _data["diagCode"];
            this.agreementNumber = _data["agreementNumber"];
            this.custId = _data["custId"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.programType = _data["programType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.subAccount = _data["subAccount"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(AuthHeaderStatus.fromJS(item));
            }
            if (Array.isArray(_data["budgetSummaries"])) {
                this.budgetSummaries = [] as any;
                for (let item of _data["budgetSummaries"])
                    this.budgetSummaries!.push(BudgetSummary.fromJS(item));
            }
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.isDraft = _data["isDraft"];
            this.insuredId = _data["insuredId"];
            this.solomonId = _data["solomonId"];
            this.clientArea = _data["clientArea"];
            this.clientTerritory = _data["clientTerritory"];
            this.clientStatus = _data["clientStatus"];
            this.transactionExist = _data["transactionExist"];
            this.payorCode = _data["payorCode"];
            this.weekStartDay = _data["weekStartDay"];
            this.programCoordinatorId = _data["programCoordinatorId"];
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): AgreementHeader {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programId"] = this.programId;
        data["programNumber"] = this.programNumber;
        data["companyCode"] = this.companyCode;
        data["companyId"] = this.companyId;
        data["acn"] = this.acn;
        data["headerAuthExternalId"] = this.headerAuthExternalId;
        data["diagId"] = this.diagId;
        data["diagCode"] = this.diagCode;
        data["agreementNumber"] = this.agreementNumber;
        data["custId"] = this.custId;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["programType"] = this.programType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["subAccount"] = this.subAccount;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item.toJSON());
        }
        if (Array.isArray(this.budgetSummaries)) {
            data["budgetSummaries"] = [];
            for (let item of this.budgetSummaries)
                data["budgetSummaries"].push(item.toJSON());
        }
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["isDraft"] = this.isDraft;
        data["insuredId"] = this.insuredId;
        data["solomonId"] = this.solomonId;
        data["clientArea"] = this.clientArea;
        data["clientTerritory"] = this.clientTerritory;
        data["clientStatus"] = this.clientStatus;
        data["transactionExist"] = this.transactionExist;
        data["payorCode"] = this.payorCode;
        data["weekStartDay"] = this.weekStartDay;
        data["programCoordinatorId"] = this.programCoordinatorId;
        data["serviceId"] = this.serviceId;
        return data;
    }
}

export interface IAgreementHeader {
    id?: number | undefined;
    programId?: number | undefined;
    programNumber?: string | undefined;
    companyCode?: string | undefined;
    companyId?: number;
    acn?: string | undefined;
    headerAuthExternalId?: string | undefined;
    diagId?: number | undefined;
    diagCode?: string | undefined;
    agreementNumber?: string | undefined;
    custId?: number | undefined;
    clientId?: string | undefined;
    clientName?: string | undefined;
    programType?: string | undefined;
    startDate?: Date | undefined;
    dob?: Date | undefined;
    endDate?: Date | undefined;
    subAccount?: string | undefined;
    status?: AuthHeaderStatus[] | undefined;
    budgetSummaries?: BudgetSummary[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    isDraft?: boolean;
    insuredId?: string | undefined;
    solomonId?: string | undefined;
    clientArea?: string | undefined;
    clientTerritory?: string | undefined;
    clientStatus?: string | undefined;
    transactionExist?: boolean;
    payorCode?: string | undefined;
    weekStartDay?: DayOfWeek;
    programCoordinatorId?: number | undefined;
    serviceId?: string | undefined;
}

export class AgreementInsuredIdResponse implements IAgreementInsuredIdResponse {
    insuredId?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IAgreementInsuredIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insuredId = _data["insuredId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgreementInsuredIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementInsuredIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuredId"] = this.insuredId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAgreementInsuredIdResponse {
    insuredId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class AgreementInsuredIdResponseIListApiResponse implements IAgreementInsuredIdResponseIListApiResponse {
    message?: string | undefined;
    data?: AgreementInsuredIdResponse[] | undefined;
    success?: boolean;

    constructor(data?: IAgreementInsuredIdResponseIListApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AgreementInsuredIdResponse.fromJS(item));
            }
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): AgreementInsuredIdResponseIListApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementInsuredIdResponseIListApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["success"] = this.success;
        return data;
    }
}

export interface IAgreementInsuredIdResponseIListApiResponse {
    message?: string | undefined;
    data?: AgreementInsuredIdResponse[] | undefined;
    success?: boolean;
}

export class AgreementLogHeaderRequest implements IAgreementLogHeaderRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    acn?: string | undefined;
    userMail?: string | undefined;
    clientId?: string | undefined;
    companyId?: number | undefined;
    companyCode?: string | undefined;

    constructor(data?: IAgreementLogHeaderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.authStartDate = _data["authStartDate"] ? new Date(_data["authStartDate"].toString()) : <any>undefined;
            this.authEndDate = _data["authEndDate"] ? new Date(_data["authEndDate"].toString()) : <any>undefined;
            this.acn = _data["acn"];
            this.userMail = _data["userMail"];
            this.clientId = _data["clientId"];
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
        }
    }

    static fromJS(data: any): AgreementLogHeaderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementLogHeaderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["authStartDate"] = this.authStartDate ? this.authStartDate.toISOString() : <any>undefined;
        data["authEndDate"] = this.authEndDate ? this.authEndDate.toISOString() : <any>undefined;
        data["acn"] = this.acn;
        data["userMail"] = this.userMail;
        data["clientId"] = this.clientId;
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        return data;
    }
}

export interface IAgreementLogHeaderRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    acn?: string | undefined;
    userMail?: string | undefined;
    clientId?: string | undefined;
    companyId?: number | undefined;
    companyCode?: string | undefined;
}

export class AgreementParticipantResponse implements IAgreementParticipantResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    personId?: string | undefined;
    solomonId?: string | undefined;
    readonly name?: string | undefined;
    status?: string | undefined;
    dob?: Date | undefined;
    territory?: string | undefined;
    area?: string | undefined;

    constructor(data?: IAgreementParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.solomonId = _data["solomonId"];
            (<any>this).name = _data["name"];
            this.status = _data["status"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.territory = _data["territory"];
            this.area = _data["area"];
        }
    }

    static fromJS(data: any): AgreementParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["solomonId"] = this.solomonId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["territory"] = this.territory;
        data["area"] = this.area;
        return data;
    }
}

export interface IAgreementParticipantResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    personId?: string | undefined;
    solomonId?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    dob?: Date | undefined;
    territory?: string | undefined;
    area?: string | undefined;
}

export class AgreementProgramsResponse implements IAgreementProgramsResponse {
    id?: number;
    name?: string | undefined;
    programType?: string | undefined;
    fundingType?: string | undefined;
    fundingSource?: string | undefined;

    constructor(data?: IAgreementProgramsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.programType = _data["programType"];
            this.fundingType = _data["fundingType"];
            this.fundingSource = _data["fundingSource"];
        }
    }

    static fromJS(data: any): AgreementProgramsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementProgramsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["programType"] = this.programType;
        data["fundingType"] = this.fundingType;
        data["fundingSource"] = this.fundingSource;
        return data;
    }
}

export interface IAgreementProgramsResponse {
    id?: number;
    name?: string | undefined;
    programType?: string | undefined;
    fundingType?: string | undefined;
    fundingSource?: string | undefined;
}

export class AgreementStatusResponse implements IAgreementStatusResponse {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IAgreementStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AgreementStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IAgreementStatusResponse {
    key?: string | undefined;
    value?: string | undefined;
}

export class AgreementUpdateRepsonse implements IAgreementUpdateRepsonse {
    budgetSummariesList?: BudgetSummary[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IAgreementUpdateRepsonse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["budgetSummariesList"])) {
                this.budgetSummariesList = [] as any;
                for (let item of _data["budgetSummariesList"])
                    this.budgetSummariesList!.push(BudgetSummary.fromJS(item));
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgreementUpdateRepsonse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementUpdateRepsonse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.budgetSummariesList)) {
            data["budgetSummariesList"] = [];
            for (let item of this.budgetSummariesList)
                data["budgetSummariesList"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAgreementUpdateRepsonse {
    budgetSummariesList?: BudgetSummary[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class AgreementUpdateRepsonseApiResponse implements IAgreementUpdateRepsonseApiResponse {
    message?: string | undefined;
    data?: AgreementUpdateRepsonse;
    success?: boolean;

    constructor(data?: IAgreementUpdateRepsonseApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.data = _data["data"] ? AgreementUpdateRepsonse.fromJS(_data["data"]) : <any>undefined;
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): AgreementUpdateRepsonseApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementUpdateRepsonseApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["success"] = this.success;
        return data;
    }
}

export interface IAgreementUpdateRepsonseApiResponse {
    message?: string | undefined;
    data?: AgreementUpdateRepsonse;
    success?: boolean;
}

export class AuthAllocation implements IAuthAllocation {
    serviceCode?: string | undefined;
    serviceType?: string | undefined;
    wwlChar?: string | undefined;
    readonly wwlFlag?: boolean;
    readonly serviceTypeDisplay?: string | undefined;
    serviceCodeId?: number | undefined;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    authDetailID?: number | undefined;
    totalAuthUnits?: number;
    billUnitRangeType?: number;
    unitMulti?: number | undefined;
    caregivers?: AuthAllocationCaregiver[] | undefined;
    weeklyAllocatableUnits?: WeeklyAllocatableUnits[] | undefined;

    constructor(data?: IAuthAllocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCode = _data["serviceCode"];
            this.serviceType = _data["serviceType"];
            this.wwlChar = _data["wwlChar"];
            (<any>this).wwlFlag = _data["wwlFlag"];
            (<any>this).serviceTypeDisplay = _data["serviceTypeDisplay"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.authStartDate = _data["authStartDate"] ? new Date(_data["authStartDate"].toString()) : <any>undefined;
            this.authEndDate = _data["authEndDate"] ? new Date(_data["authEndDate"].toString()) : <any>undefined;
            this.authDetailID = _data["authDetailID"];
            this.totalAuthUnits = _data["totalAuthUnits"];
            this.billUnitRangeType = _data["billUnitRangeType"];
            this.unitMulti = _data["unitMulti"];
            if (Array.isArray(_data["caregivers"])) {
                this.caregivers = [] as any;
                for (let item of _data["caregivers"])
                    this.caregivers!.push(AuthAllocationCaregiver.fromJS(item));
            }
            if (Array.isArray(_data["weeklyAllocatableUnits"])) {
                this.weeklyAllocatableUnits = [] as any;
                for (let item of _data["weeklyAllocatableUnits"])
                    this.weeklyAllocatableUnits!.push(WeeklyAllocatableUnits.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthAllocation {
        data = typeof data === 'object' ? data : {};
        let result = new AuthAllocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCode"] = this.serviceCode;
        data["serviceType"] = this.serviceType;
        data["wwlChar"] = this.wwlChar;
        data["wwlFlag"] = this.wwlFlag;
        data["serviceTypeDisplay"] = this.serviceTypeDisplay;
        data["serviceCodeId"] = this.serviceCodeId;
        data["authStartDate"] = this.authStartDate ? this.authStartDate.toISOString() : <any>undefined;
        data["authEndDate"] = this.authEndDate ? this.authEndDate.toISOString() : <any>undefined;
        data["authDetailID"] = this.authDetailID;
        data["totalAuthUnits"] = this.totalAuthUnits;
        data["billUnitRangeType"] = this.billUnitRangeType;
        data["unitMulti"] = this.unitMulti;
        if (Array.isArray(this.caregivers)) {
            data["caregivers"] = [];
            for (let item of this.caregivers)
                data["caregivers"].push(item.toJSON());
        }
        if (Array.isArray(this.weeklyAllocatableUnits)) {
            data["weeklyAllocatableUnits"] = [];
            for (let item of this.weeklyAllocatableUnits)
                data["weeklyAllocatableUnits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuthAllocation {
    serviceCode?: string | undefined;
    serviceType?: string | undefined;
    wwlChar?: string | undefined;
    wwlFlag?: boolean;
    serviceTypeDisplay?: string | undefined;
    serviceCodeId?: number | undefined;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    authDetailID?: number | undefined;
    totalAuthUnits?: number;
    billUnitRangeType?: number;
    unitMulti?: number | undefined;
    caregivers?: AuthAllocationCaregiver[] | undefined;
    weeklyAllocatableUnits?: WeeklyAllocatableUnits[] | undefined;
}

export class AuthAllocationCaregiver implements IAuthAllocationCaregiver {
    serviceCodeId?: number | undefined;
    caregiverPersonId?: string | undefined;
    caregiverId?: number | undefined;
    caregiverParticipantMappingId?: number | undefined;
    caregiverEmployerMappingId?: number;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    allocatedUnits?: number | undefined;
    usedUnits?: number;
    relationshipStartDate?: Date | undefined;
    relationshipEndDate?: Date | undefined;
    allocationWeekStart?: Date;
    allocationWeekEnd?: Date;
    wwlChar?: string | undefined;
    readonly wwlFlag?: boolean;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    unitMulti?: number;

    constructor(data?: IAuthAllocationCaregiver) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCodeId = _data["serviceCodeId"];
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverParticipantMappingId = _data["caregiverParticipantMappingId"];
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.allocatedUnits = _data["allocatedUnits"];
            this.usedUnits = _data["usedUnits"];
            this.relationshipStartDate = _data["relationshipStartDate"] ? new Date(_data["relationshipStartDate"].toString()) : <any>undefined;
            this.relationshipEndDate = _data["relationshipEndDate"] ? new Date(_data["relationshipEndDate"].toString()) : <any>undefined;
            this.allocationWeekStart = _data["allocationWeekStart"] ? new Date(_data["allocationWeekStart"].toString()) : <any>undefined;
            this.allocationWeekEnd = _data["allocationWeekEnd"] ? new Date(_data["allocationWeekEnd"].toString()) : <any>undefined;
            this.wwlChar = _data["wwlChar"];
            (<any>this).wwlFlag = _data["wwlFlag"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.unitMulti = _data["unitMulti"];
        }
    }

    static fromJS(data: any): AuthAllocationCaregiver {
        data = typeof data === 'object' ? data : {};
        let result = new AuthAllocationCaregiver();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCodeId"] = this.serviceCodeId;
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["caregiverId"] = this.caregiverId;
        data["caregiverParticipantMappingId"] = this.caregiverParticipantMappingId;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["allocatedUnits"] = this.allocatedUnits;
        data["usedUnits"] = this.usedUnits;
        data["relationshipStartDate"] = this.relationshipStartDate ? this.relationshipStartDate.toISOString() : <any>undefined;
        data["relationshipEndDate"] = this.relationshipEndDate ? this.relationshipEndDate.toISOString() : <any>undefined;
        data["allocationWeekStart"] = this.allocationWeekStart ? this.allocationWeekStart.toISOString() : <any>undefined;
        data["allocationWeekEnd"] = this.allocationWeekEnd ? this.allocationWeekEnd.toISOString() : <any>undefined;
        data["wwlChar"] = this.wwlChar;
        data["wwlFlag"] = this.wwlFlag;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["unitMulti"] = this.unitMulti;
        return data;
    }
}

export interface IAuthAllocationCaregiver {
    serviceCodeId?: number | undefined;
    caregiverPersonId?: string | undefined;
    caregiverId?: number | undefined;
    caregiverParticipantMappingId?: number | undefined;
    caregiverEmployerMappingId?: number;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    allocatedUnits?: number | undefined;
    usedUnits?: number;
    relationshipStartDate?: Date | undefined;
    relationshipEndDate?: Date | undefined;
    allocationWeekStart?: Date;
    allocationWeekEnd?: Date;
    wwlChar?: string | undefined;
    wwlFlag?: boolean;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    unitMulti?: number;
}

export class AuthAllocationDetail implements IAuthAllocationDetail {
    participantPersonId?: string | undefined;
    participantId?: number;
    participantFirstname?: string | undefined;
    participantLastName?: string | undefined;
    authAllocations?: AuthAllocation[] | undefined;
    authAllocationsAll?: AuthAllocation[] | undefined;

    constructor(data?: IAuthAllocationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantPersonId = _data["participantPersonId"];
            this.participantId = _data["participantId"];
            this.participantFirstname = _data["participantFirstname"];
            this.participantLastName = _data["participantLastName"];
            if (Array.isArray(_data["authAllocations"])) {
                this.authAllocations = [] as any;
                for (let item of _data["authAllocations"])
                    this.authAllocations!.push(AuthAllocation.fromJS(item));
            }
            if (Array.isArray(_data["authAllocationsAll"])) {
                this.authAllocationsAll = [] as any;
                for (let item of _data["authAllocationsAll"])
                    this.authAllocationsAll!.push(AuthAllocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthAllocationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AuthAllocationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantPersonId"] = this.participantPersonId;
        data["participantId"] = this.participantId;
        data["participantFirstname"] = this.participantFirstname;
        data["participantLastName"] = this.participantLastName;
        if (Array.isArray(this.authAllocations)) {
            data["authAllocations"] = [];
            for (let item of this.authAllocations)
                data["authAllocations"].push(item.toJSON());
        }
        if (Array.isArray(this.authAllocationsAll)) {
            data["authAllocationsAll"] = [];
            for (let item of this.authAllocationsAll)
                data["authAllocationsAll"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuthAllocationDetail {
    participantPersonId?: string | undefined;
    participantId?: number;
    participantFirstname?: string | undefined;
    participantLastName?: string | undefined;
    authAllocations?: AuthAllocation[] | undefined;
    authAllocationsAll?: AuthAllocation[] | undefined;
}

export class AuthAllocationRequest implements IAuthAllocationRequest {
    rollForward?: boolean | undefined;
    rollForwardEndDate?: Date | undefined;
    participantPersonId?: string | undefined;
    caregiverPersonId?: string | undefined;
    serviceCode?: string | undefined;
    allocatedUnits?: number;
    startDate?: Date;
    endDate?: Date;
    userMail?: string | undefined;
    authAllocations?: AuthAllocation[] | undefined;

    constructor(data?: IAuthAllocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rollForward = _data["rollForward"];
            this.rollForwardEndDate = _data["rollForwardEndDate"] ? new Date(_data["rollForwardEndDate"].toString()) : <any>undefined;
            this.participantPersonId = _data["participantPersonId"];
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.serviceCode = _data["serviceCode"];
            this.allocatedUnits = _data["allocatedUnits"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.userMail = _data["userMail"];
            if (Array.isArray(_data["authAllocations"])) {
                this.authAllocations = [] as any;
                for (let item of _data["authAllocations"])
                    this.authAllocations!.push(AuthAllocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthAllocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthAllocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rollForward"] = this.rollForward;
        data["rollForwardEndDate"] = this.rollForwardEndDate ? this.rollForwardEndDate.toISOString() : <any>undefined;
        data["participantPersonId"] = this.participantPersonId;
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["serviceCode"] = this.serviceCode;
        data["allocatedUnits"] = this.allocatedUnits;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["userMail"] = this.userMail;
        if (Array.isArray(this.authAllocations)) {
            data["authAllocations"] = [];
            for (let item of this.authAllocations)
                data["authAllocations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuthAllocationRequest {
    rollForward?: boolean | undefined;
    rollForwardEndDate?: Date | undefined;
    participantPersonId?: string | undefined;
    caregiverPersonId?: string | undefined;
    serviceCode?: string | undefined;
    allocatedUnits?: number;
    startDate?: Date;
    endDate?: Date;
    userMail?: string | undefined;
    authAllocations?: AuthAllocation[] | undefined;
}

export class AuthAllocationsExpiryRequest implements IAuthAllocationsExpiryRequest {
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IAuthAllocationsExpiryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthAllocationsExpiryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthAllocationsExpiryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthAllocationsExpiryRequest {
    startDate?: Date;
    endDate?: Date;
}

export class AuthAllocationsExpiryResponse implements IAuthAllocationsExpiryResponse {
    participantPersonId?: string | undefined;
    caregiverPersonId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    serviceCode?: string | undefined;

    constructor(data?: IAuthAllocationsExpiryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantPersonId = _data["participantPersonId"];
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.serviceCode = _data["serviceCode"];
        }
    }

    static fromJS(data: any): AuthAllocationsExpiryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthAllocationsExpiryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantPersonId"] = this.participantPersonId;
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["serviceCode"] = this.serviceCode;
        return data;
    }
}

export interface IAuthAllocationsExpiryResponse {
    participantPersonId?: string | undefined;
    caregiverPersonId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    serviceCode?: string | undefined;
}

export class AuthBalanceDetailResponse implements IAuthBalanceDetailResponse {
    budgetUnits?: number | undefined;
    balanceUnits?: number | undefined;
    budgetAmount?: number | undefined;
    balanceAmount?: number | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IAuthBalanceDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetUnits = _data["budgetUnits"];
            this.balanceUnits = _data["balanceUnits"];
            this.budgetAmount = _data["budgetAmount"];
            this.balanceAmount = _data["balanceAmount"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthBalanceDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthBalanceDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetUnits"] = this.budgetUnits;
        data["balanceUnits"] = this.balanceUnits;
        data["budgetAmount"] = this.budgetAmount;
        data["balanceAmount"] = this.balanceAmount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthBalanceDetailResponse {
    budgetUnits?: number | undefined;
    balanceUnits?: number | undefined;
    budgetAmount?: number | undefined;
    balanceAmount?: number | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class AuthCodeLkpByParticipantRequest implements IAuthCodeLkpByParticipantRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
    serveCodeIds?: number[] | undefined;
    participantId?: number;

    constructor(data?: IAuthCodeLkpByParticipantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.searchParameter = _data["searchParameter"];
            if (Array.isArray(_data["serveCodeIds"])) {
                this.serveCodeIds = [] as any;
                for (let item of _data["serveCodeIds"])
                    this.serveCodeIds!.push(item);
            }
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): AuthCodeLkpByParticipantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthCodeLkpByParticipantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["searchParameter"] = this.searchParameter;
        if (Array.isArray(this.serveCodeIds)) {
            data["serveCodeIds"] = [];
            for (let item of this.serveCodeIds)
                data["serveCodeIds"].push(item);
        }
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface IAuthCodeLkpByParticipantRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
    serveCodeIds?: number[] | undefined;
    participantId?: number;
}

export class AuthCodeLkpByParticipantResponse implements IAuthCodeLkpByParticipantResponse {
    id?: number;
    authCode?: string | undefined;
    custId?: number;
    clientId?: string | undefined;
    clientName?: string | undefined;
    servCode?: string | undefined;

    constructor(data?: IAuthCodeLkpByParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.authCode = _data["authCode"];
            this.custId = _data["custId"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.servCode = _data["servCode"];
        }
    }

    static fromJS(data: any): AuthCodeLkpByParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthCodeLkpByParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["authCode"] = this.authCode;
        data["custId"] = this.custId;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["servCode"] = this.servCode;
        return data;
    }
}

export interface IAuthCodeLkpByParticipantResponse {
    id?: number;
    authCode?: string | undefined;
    custId?: number;
    clientId?: string | undefined;
    clientName?: string | undefined;
    servCode?: string | undefined;
}

export class AuthCodeLkpByParticipantResponseGridResponseBase implements IAuthCodeLkpByParticipantResponseGridResponseBase {
    items?: AuthCodeLkpByParticipantResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: AuthCodeLkpByParticipantResponse;

    constructor(data?: IAuthCodeLkpByParticipantResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuthCodeLkpByParticipantResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? AuthCodeLkpByParticipantResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthCodeLkpByParticipantResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new AuthCodeLkpByParticipantResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuthCodeLkpByParticipantResponseGridResponseBase {
    items?: AuthCodeLkpByParticipantResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: AuthCodeLkpByParticipantResponse;
}

export class AuthDetailSnapshotSummaryResponse implements IAuthDetailSnapshotSummaryResponse {
    servCode?: string | undefined;
    servCodeDescription?: string | undefined;
    unitType?: string | undefined;
    authBudget?: number;
    authSpent?: number;
    authReserved?: number;
    authBalance?: number;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IAuthDetailSnapshotSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servCode = _data["servCode"];
            this.servCodeDescription = _data["servCodeDescription"];
            this.unitType = _data["unitType"];
            this.authBudget = _data["authBudget"];
            this.authSpent = _data["authSpent"];
            this.authReserved = _data["authReserved"];
            this.authBalance = _data["authBalance"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthDetailSnapshotSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthDetailSnapshotSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servCode"] = this.servCode;
        data["servCodeDescription"] = this.servCodeDescription;
        data["unitType"] = this.unitType;
        data["authBudget"] = this.authBudget;
        data["authSpent"] = this.authSpent;
        data["authReserved"] = this.authReserved;
        data["authBalance"] = this.authBalance;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthDetailSnapshotSummaryResponse {
    servCode?: string | undefined;
    servCodeDescription?: string | undefined;
    unitType?: string | undefined;
    authBudget?: number;
    authSpent?: number;
    authReserved?: number;
    authBalance?: number;
    startDate?: Date;
    endDate?: Date;
}

export class AuthDetailSummaryRequest implements IAuthDetailSummaryRequest {
    servCode?: string | undefined;
    servDate?: Date;
    participantId?: string | undefined;

    constructor(data?: IAuthDetailSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servCode = _data["servCode"];
            this.servDate = _data["servDate"] ? new Date(_data["servDate"].toString()) : <any>undefined;
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): AuthDetailSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthDetailSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servCode"] = this.servCode;
        data["servDate"] = this.servDate ? this.servDate.toISOString() : <any>undefined;
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface IAuthDetailSummaryRequest {
    servCode?: string | undefined;
    servDate?: Date;
    participantId?: string | undefined;
}

export class AuthDetailSummaryResponse implements IAuthDetailSummaryResponse {
    acn?: string | undefined;
    authCode?: string | undefined;
    companyCode?: string | undefined;
    servCode?: string | undefined;
    servDate?: Date;
    insuredId?: string | undefined;
    participantId?: string | undefined;
    payor?: string | undefined;
    payorId?: string | undefined;
    program?: string | undefined;
    diagCode?: string | undefined;
    agreementNumber?: string | undefined;
    unitType?: string | undefined;
    authBalance?: AuthBalanceDetailResponse;
    authRangeBalance?: AuthRangeDetailResponse;
    authStatus?: string | undefined;
    headerStatus?: string | undefined;
    detailsStatus?: string | undefined;
    revenueAccountId?: number | undefined;
    revenueAccount?: string | undefined;
    mileageExpenseAccountId?: number | undefined;
    mileageExpenseAccount?: string | undefined;
    payrollExpenseAccountId?: number | undefined;
    payrollExpenseAccount?: string | undefined;
    payrollOtExpenseAccountId?: number | undefined;
    payrollOtExpenseAccount?: string | undefined;
    accountsPayableAccountId?: number | undefined;
    accountsPayableAccount?: string | undefined;
    subAccount?: string | undefined;
    passportId?: string | undefined;
    attendingProviderNumber?: string | undefined;
    referringProviderNumber?: string | undefined;

    constructor(data?: IAuthDetailSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acn = _data["acn"];
            this.authCode = _data["authCode"];
            this.companyCode = _data["companyCode"];
            this.servCode = _data["servCode"];
            this.servDate = _data["servDate"] ? new Date(_data["servDate"].toString()) : <any>undefined;
            this.insuredId = _data["insuredId"];
            this.participantId = _data["participantId"];
            this.payor = _data["payor"];
            this.payorId = _data["payorId"];
            this.program = _data["program"];
            this.diagCode = _data["diagCode"];
            this.agreementNumber = _data["agreementNumber"];
            this.unitType = _data["unitType"];
            this.authBalance = _data["authBalance"] ? AuthBalanceDetailResponse.fromJS(_data["authBalance"]) : <any>undefined;
            this.authRangeBalance = _data["authRangeBalance"] ? AuthRangeDetailResponse.fromJS(_data["authRangeBalance"]) : <any>undefined;
            this.authStatus = _data["authStatus"];
            this.headerStatus = _data["headerStatus"];
            this.detailsStatus = _data["detailsStatus"];
            this.revenueAccountId = _data["revenueAccountId"];
            this.revenueAccount = _data["revenueAccount"];
            this.mileageExpenseAccountId = _data["mileageExpenseAccountId"];
            this.mileageExpenseAccount = _data["mileageExpenseAccount"];
            this.payrollExpenseAccountId = _data["payrollExpenseAccountId"];
            this.payrollExpenseAccount = _data["payrollExpenseAccount"];
            this.payrollOtExpenseAccountId = _data["payrollOtExpenseAccountId"];
            this.payrollOtExpenseAccount = _data["payrollOtExpenseAccount"];
            this.accountsPayableAccountId = _data["accountsPayableAccountId"];
            this.accountsPayableAccount = _data["accountsPayableAccount"];
            this.subAccount = _data["subAccount"];
            this.passportId = _data["passportId"];
            this.attendingProviderNumber = _data["attendingProviderNumber"];
            this.referringProviderNumber = _data["referringProviderNumber"];
        }
    }

    static fromJS(data: any): AuthDetailSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthDetailSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acn"] = this.acn;
        data["authCode"] = this.authCode;
        data["companyCode"] = this.companyCode;
        data["servCode"] = this.servCode;
        data["servDate"] = this.servDate ? this.servDate.toISOString() : <any>undefined;
        data["insuredId"] = this.insuredId;
        data["participantId"] = this.participantId;
        data["payor"] = this.payor;
        data["payorId"] = this.payorId;
        data["program"] = this.program;
        data["diagCode"] = this.diagCode;
        data["agreementNumber"] = this.agreementNumber;
        data["unitType"] = this.unitType;
        data["authBalance"] = this.authBalance ? this.authBalance.toJSON() : <any>undefined;
        data["authRangeBalance"] = this.authRangeBalance ? this.authRangeBalance.toJSON() : <any>undefined;
        data["authStatus"] = this.authStatus;
        data["headerStatus"] = this.headerStatus;
        data["detailsStatus"] = this.detailsStatus;
        data["revenueAccountId"] = this.revenueAccountId;
        data["revenueAccount"] = this.revenueAccount;
        data["mileageExpenseAccountId"] = this.mileageExpenseAccountId;
        data["mileageExpenseAccount"] = this.mileageExpenseAccount;
        data["payrollExpenseAccountId"] = this.payrollExpenseAccountId;
        data["payrollExpenseAccount"] = this.payrollExpenseAccount;
        data["payrollOtExpenseAccountId"] = this.payrollOtExpenseAccountId;
        data["payrollOtExpenseAccount"] = this.payrollOtExpenseAccount;
        data["accountsPayableAccountId"] = this.accountsPayableAccountId;
        data["accountsPayableAccount"] = this.accountsPayableAccount;
        data["subAccount"] = this.subAccount;
        data["passportId"] = this.passportId;
        data["attendingProviderNumber"] = this.attendingProviderNumber;
        data["referringProviderNumber"] = this.referringProviderNumber;
        return data;
    }
}

export interface IAuthDetailSummaryResponse {
    acn?: string | undefined;
    authCode?: string | undefined;
    companyCode?: string | undefined;
    servCode?: string | undefined;
    servDate?: Date;
    insuredId?: string | undefined;
    participantId?: string | undefined;
    payor?: string | undefined;
    payorId?: string | undefined;
    program?: string | undefined;
    diagCode?: string | undefined;
    agreementNumber?: string | undefined;
    unitType?: string | undefined;
    authBalance?: AuthBalanceDetailResponse;
    authRangeBalance?: AuthRangeDetailResponse;
    authStatus?: string | undefined;
    headerStatus?: string | undefined;
    detailsStatus?: string | undefined;
    revenueAccountId?: number | undefined;
    revenueAccount?: string | undefined;
    mileageExpenseAccountId?: number | undefined;
    mileageExpenseAccount?: string | undefined;
    payrollExpenseAccountId?: number | undefined;
    payrollExpenseAccount?: string | undefined;
    payrollOtExpenseAccountId?: number | undefined;
    payrollOtExpenseAccount?: string | undefined;
    accountsPayableAccountId?: number | undefined;
    accountsPayableAccount?: string | undefined;
    subAccount?: string | undefined;
    passportId?: string | undefined;
    attendingProviderNumber?: string | undefined;
    referringProviderNumber?: string | undefined;
}

export class AuthDetailWaiverCode implements IAuthDetailWaiverCode {
    authDetailsId?: number | undefined;
    waiverCode?: string | undefined;
    waiverCodeId?: number;
    waiverName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: IAuthDetailWaiverCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authDetailsId = _data["authDetailsId"];
            this.waiverCode = _data["waiverCode"];
            this.waiverCodeId = _data["waiverCodeId"];
            this.waiverName = _data["waiverName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthDetailWaiverCode {
        data = typeof data === 'object' ? data : {};
        let result = new AuthDetailWaiverCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authDetailsId"] = this.authDetailsId;
        data["waiverCode"] = this.waiverCode;
        data["waiverCodeId"] = this.waiverCodeId;
        data["waiverName"] = this.waiverName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthDetailWaiverCode {
    authDetailsId?: number | undefined;
    waiverCode?: string | undefined;
    waiverCodeId?: number;
    waiverName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
}

export class AuthDetailsTransactionRequest implements IAuthDetailsTransactionRequest {
    participantId?: string | undefined;
    agreementNumber?: string | undefined;
    serviceCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IAuthDetailsTransactionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.agreementNumber = _data["agreementNumber"];
            this.serviceCode = _data["serviceCode"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthDetailsTransactionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthDetailsTransactionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["agreementNumber"] = this.agreementNumber;
        data["serviceCode"] = this.serviceCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthDetailsTransactionRequest {
    participantId?: string | undefined;
    agreementNumber?: string | undefined;
    serviceCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class AuthHeaderDetails implements IAuthHeaderDetails {
    acn?: string | undefined;
    diagId?: number;
    participantId?: number;
    agreeNumber?: string | undefined;
    begDate?: Date;
    ecmid?: number;
    endDate?: Date;
    noteId?: number;
    subAcc?: string | undefined;
    isDeleted?: boolean;
    programId?: number;
    isDraft?: boolean;
    programCoordinatorId?: number;
    serviceId?: string | undefined;

    constructor(data?: IAuthHeaderDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acn = _data["acn"];
            this.diagId = _data["diagId"];
            this.participantId = _data["participantId"];
            this.agreeNumber = _data["agreeNumber"];
            this.begDate = _data["begDate"] ? new Date(_data["begDate"].toString()) : <any>undefined;
            this.ecmid = _data["ecmid"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.noteId = _data["noteId"];
            this.subAcc = _data["subAcc"];
            this.isDeleted = _data["isDeleted"];
            this.programId = _data["programId"];
            this.isDraft = _data["isDraft"];
            this.programCoordinatorId = _data["programCoordinatorId"];
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): AuthHeaderDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AuthHeaderDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acn"] = this.acn;
        data["diagId"] = this.diagId;
        data["participantId"] = this.participantId;
        data["agreeNumber"] = this.agreeNumber;
        data["begDate"] = this.begDate ? this.begDate.toISOString() : <any>undefined;
        data["ecmid"] = this.ecmid;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["noteId"] = this.noteId;
        data["subAcc"] = this.subAcc;
        data["isDeleted"] = this.isDeleted;
        data["programId"] = this.programId;
        data["isDraft"] = this.isDraft;
        data["programCoordinatorId"] = this.programCoordinatorId;
        data["serviceId"] = this.serviceId;
        return data;
    }
}

export interface IAuthHeaderDetails {
    acn?: string | undefined;
    diagId?: number;
    participantId?: number;
    agreeNumber?: string | undefined;
    begDate?: Date;
    ecmid?: number;
    endDate?: Date;
    noteId?: number;
    subAcc?: string | undefined;
    isDeleted?: boolean;
    programId?: number;
    isDraft?: boolean;
    programCoordinatorId?: number;
    serviceId?: string | undefined;
}

export class AuthHeaderStatus implements IAuthHeaderStatus {
    code?: string | undefined;

    constructor(data?: IAuthHeaderStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): AuthHeaderStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AuthHeaderStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IAuthHeaderStatus {
    code?: string | undefined;
}

export class AuthInternalTransactionRequest implements IAuthInternalTransactionRequest {
    serviceCode?: string | undefined;
    caregiverId?: string | undefined;
    transactionDate?: Date;
    employerId?: string | undefined;
    amount?: number | undefined;
    transactionType?: string | undefined;
    transactionSubType?: string | undefined;
    transactionSource?: string | undefined;
    transactionId?: string | undefined;

    constructor(data?: IAuthInternalTransactionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCode = _data["serviceCode"];
            this.caregiverId = _data["caregiverId"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.employerId = _data["employerId"];
            this.amount = _data["amount"];
            this.transactionType = _data["transactionType"];
            this.transactionSubType = _data["transactionSubType"];
            this.transactionSource = _data["transactionSource"];
            this.transactionId = _data["transactionId"];
        }
    }

    static fromJS(data: any): AuthInternalTransactionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthInternalTransactionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCode"] = this.serviceCode;
        data["caregiverId"] = this.caregiverId;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["employerId"] = this.employerId;
        data["amount"] = this.amount;
        data["transactionType"] = this.transactionType;
        data["transactionSubType"] = this.transactionSubType;
        data["transactionSource"] = this.transactionSource;
        data["transactionId"] = this.transactionId;
        return data;
    }
}

export interface IAuthInternalTransactionRequest {
    serviceCode?: string | undefined;
    caregiverId?: string | undefined;
    transactionDate?: Date;
    employerId?: string | undefined;
    amount?: number | undefined;
    transactionType?: string | undefined;
    transactionSubType?: string | undefined;
    transactionSource?: string | undefined;
    transactionId?: string | undefined;
}

export class AuthLedgerTransaction implements IAuthLedgerTransaction {
    serviceCode?: string | undefined;
    description?: string | undefined;
    transactionType?: string | undefined;
    tranDisplayType?: string | undefined;
    transactionDate?: Date;
    transactionId?: string | undefined;
    units?: number;
    updatedBalance?: number;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IAuthLedgerTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCode = _data["serviceCode"];
            this.description = _data["description"];
            this.transactionType = _data["transactionType"];
            this.tranDisplayType = _data["tranDisplayType"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.transactionId = _data["transactionId"];
            this.units = _data["units"];
            this.updatedBalance = _data["updatedBalance"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthLedgerTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLedgerTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCode"] = this.serviceCode;
        data["description"] = this.description;
        data["transactionType"] = this.transactionType;
        data["tranDisplayType"] = this.tranDisplayType;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["transactionId"] = this.transactionId;
        data["units"] = this.units;
        data["updatedBalance"] = this.updatedBalance;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthLedgerTransaction {
    serviceCode?: string | undefined;
    description?: string | undefined;
    transactionType?: string | undefined;
    tranDisplayType?: string | undefined;
    transactionDate?: Date;
    transactionId?: string | undefined;
    units?: number;
    updatedBalance?: number;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class AuthLedgerTransactionHolder implements IAuthLedgerTransactionHolder {
    authLedgerTransactions?: AuthLedgerTransaction[] | undefined;
    pageNumber?: number;
    totalRecords?: number;
    totalPages?: number;

    constructor(data?: IAuthLedgerTransactionHolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["authLedgerTransactions"])) {
                this.authLedgerTransactions = [] as any;
                for (let item of _data["authLedgerTransactions"])
                    this.authLedgerTransactions!.push(AuthLedgerTransaction.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): AuthLedgerTransactionHolder {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLedgerTransactionHolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.authLedgerTransactions)) {
            data["authLedgerTransactions"] = [];
            for (let item of this.authLedgerTransactions)
                data["authLedgerTransactions"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IAuthLedgerTransactionHolder {
    authLedgerTransactions?: AuthLedgerTransaction[] | undefined;
    pageNumber?: number;
    totalRecords?: number;
    totalPages?: number;
}

export class AuthOwnersRequest implements IAuthOwnersRequest {
    authDetailId?: string | undefined;
    authHeaderId?: string | undefined;
    ownerType?: string | undefined;
    filterRequest?: FilterRequest;

    constructor(data?: IAuthOwnersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authDetailId = _data["authDetailId"];
            this.authHeaderId = _data["authHeaderId"];
            this.ownerType = _data["ownerType"];
            this.filterRequest = _data["filterRequest"] ? FilterRequest.fromJS(_data["filterRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthOwnersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthOwnersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authDetailId"] = this.authDetailId;
        data["authHeaderId"] = this.authHeaderId;
        data["ownerType"] = this.ownerType;
        data["filterRequest"] = this.filterRequest ? this.filterRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuthOwnersRequest {
    authDetailId?: string | undefined;
    authHeaderId?: string | undefined;
    ownerType?: string | undefined;
    filterRequest?: FilterRequest;
}

export class AuthRangeDetailResponse implements IAuthRangeDetailResponse {
    rangeBudgetUnits?: number | undefined;
    balanceUnits?: number | undefined;
    rangeBudgetAmount?: number | undefined;
    balanceAmount?: number | undefined;
    unitStartDate?: Date | undefined;
    unitEndDate?: Date | undefined;
    amountStartDate?: Date | undefined;
    amountEndDate?: Date | undefined;

    constructor(data?: IAuthRangeDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rangeBudgetUnits = _data["rangeBudgetUnits"];
            this.balanceUnits = _data["balanceUnits"];
            this.rangeBudgetAmount = _data["rangeBudgetAmount"];
            this.balanceAmount = _data["balanceAmount"];
            this.unitStartDate = _data["unitStartDate"] ? new Date(_data["unitStartDate"].toString()) : <any>undefined;
            this.unitEndDate = _data["unitEndDate"] ? new Date(_data["unitEndDate"].toString()) : <any>undefined;
            this.amountStartDate = _data["amountStartDate"] ? new Date(_data["amountStartDate"].toString()) : <any>undefined;
            this.amountEndDate = _data["amountEndDate"] ? new Date(_data["amountEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthRangeDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthRangeDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rangeBudgetUnits"] = this.rangeBudgetUnits;
        data["balanceUnits"] = this.balanceUnits;
        data["rangeBudgetAmount"] = this.rangeBudgetAmount;
        data["balanceAmount"] = this.balanceAmount;
        data["unitStartDate"] = this.unitStartDate ? this.unitStartDate.toISOString() : <any>undefined;
        data["unitEndDate"] = this.unitEndDate ? this.unitEndDate.toISOString() : <any>undefined;
        data["amountStartDate"] = this.amountStartDate ? this.amountStartDate.toISOString() : <any>undefined;
        data["amountEndDate"] = this.amountEndDate ? this.amountEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthRangeDetailResponse {
    rangeBudgetUnits?: number | undefined;
    balanceUnits?: number | undefined;
    rangeBudgetAmount?: number | undefined;
    balanceAmount?: number | undefined;
    unitStartDate?: Date | undefined;
    unitEndDate?: Date | undefined;
    amountStartDate?: Date | undefined;
    amountEndDate?: Date | undefined;
}

export class AuthTransactionRequest implements IAuthTransactionRequest {
    transactionId?: string | undefined;
    refTransactionId?: string | undefined;
    extId?: string | undefined;
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;
    estimatedBillAmt?: number | undefined;
    actualBillAmt?: number | undefined;
    billHrs?: number | undefined;
    payorCode?: string | undefined;
    programCode?: string | undefined;
    insuredId?: string | undefined;
    authCode?: string | undefined;
    debit?: boolean;
    calHrs?: number | undefined;
    companyCode?: string | undefined;

    constructor(data?: IAuthTransactionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.refTransactionId = _data["refTransactionId"];
            this.extId = _data["extId"];
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.serviceCode = _data["serviceCode"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.estimatedBillAmt = _data["estimatedBillAmt"];
            this.actualBillAmt = _data["actualBillAmt"];
            this.billHrs = _data["billHrs"];
            this.payorCode = _data["payorCode"];
            this.programCode = _data["programCode"];
            this.insuredId = _data["insuredId"];
            this.authCode = _data["authCode"];
            this.debit = _data["debit"];
            this.calHrs = _data["calHrs"];
            this.companyCode = _data["companyCode"];
        }
    }

    static fromJS(data: any): AuthTransactionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthTransactionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["refTransactionId"] = this.refTransactionId;
        data["extId"] = this.extId;
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["serviceCode"] = this.serviceCode;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["estimatedBillAmt"] = this.estimatedBillAmt;
        data["actualBillAmt"] = this.actualBillAmt;
        data["billHrs"] = this.billHrs;
        data["payorCode"] = this.payorCode;
        data["programCode"] = this.programCode;
        data["insuredId"] = this.insuredId;
        data["authCode"] = this.authCode;
        data["debit"] = this.debit;
        data["calHrs"] = this.calHrs;
        data["companyCode"] = this.companyCode;
        return data;
    }
}

export interface IAuthTransactionRequest {
    transactionId?: string | undefined;
    refTransactionId?: string | undefined;
    extId?: string | undefined;
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;
    estimatedBillAmt?: number | undefined;
    actualBillAmt?: number | undefined;
    billHrs?: number | undefined;
    payorCode?: string | undefined;
    programCode?: string | undefined;
    insuredId?: string | undefined;
    authCode?: string | undefined;
    debit?: boolean;
    calHrs?: number | undefined;
    companyCode?: string | undefined;
}

export enum AuthType {
    None = "None",
    Internal = "Internal",
    Participant = "Participant",
    Both = "Both",
}

export class Authorization implements IAuthorization {
    id?: number | undefined;
    programId?: number | undefined;
    programNumber?: string | undefined;
    companyCode?: string | undefined;
    authStatus?: string | undefined;
    agreementNumber?: string | undefined;
    clientId?: string | undefined;
    solomonId?: string | undefined;
    clientName?: string | undefined;
    dob?: Date | undefined;
    status?: AuthorizationStatus;
    clientStatus?: string | undefined;
    insuredId?: string | undefined;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    acn?: string | undefined;

    constructor(data?: IAuthorization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programId = _data["programId"];
            this.programNumber = _data["programNumber"];
            this.companyCode = _data["companyCode"];
            this.authStatus = _data["authStatus"];
            this.agreementNumber = _data["agreementNumber"];
            this.clientId = _data["clientId"];
            this.solomonId = _data["solomonId"];
            this.clientName = _data["clientName"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.clientStatus = _data["clientStatus"];
            this.insuredId = _data["insuredId"];
            this.authStartDate = _data["authStartDate"] ? new Date(_data["authStartDate"].toString()) : <any>undefined;
            this.authEndDate = _data["authEndDate"] ? new Date(_data["authEndDate"].toString()) : <any>undefined;
            this.acn = _data["acn"];
        }
    }

    static fromJS(data: any): Authorization {
        data = typeof data === 'object' ? data : {};
        let result = new Authorization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programId"] = this.programId;
        data["programNumber"] = this.programNumber;
        data["companyCode"] = this.companyCode;
        data["authStatus"] = this.authStatus;
        data["agreementNumber"] = this.agreementNumber;
        data["clientId"] = this.clientId;
        data["solomonId"] = this.solomonId;
        data["clientName"] = this.clientName;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["clientStatus"] = this.clientStatus;
        data["insuredId"] = this.insuredId;
        data["authStartDate"] = this.authStartDate ? this.authStartDate.toISOString() : <any>undefined;
        data["authEndDate"] = this.authEndDate ? this.authEndDate.toISOString() : <any>undefined;
        data["acn"] = this.acn;
        return data;
    }
}

export interface IAuthorization {
    id?: number | undefined;
    programId?: number | undefined;
    programNumber?: string | undefined;
    companyCode?: string | undefined;
    authStatus?: string | undefined;
    agreementNumber?: string | undefined;
    clientId?: string | undefined;
    solomonId?: string | undefined;
    clientName?: string | undefined;
    dob?: Date | undefined;
    status?: AuthorizationStatus;
    clientStatus?: string | undefined;
    insuredId?: string | undefined;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    acn?: string | undefined;
}

export enum AuthorizationDetailsStatus {
    SAAC = "SAAC",
    SAIA = "SAIA",
    SAHT = "SAHT",
    SAHP = "SAHP",
    SAHB = "SAHB",
}

export class AuthorizationExpiryRequest implements IAuthorizationExpiryRequest {
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IAuthorizationExpiryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthorizationExpiryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationExpiryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthorizationExpiryRequest {
    startDate?: Date;
    endDate?: Date;
}

export class AuthorizationExpiryResponse implements IAuthorizationExpiryResponse {
    authId?: string | undefined;
    participantPersonId?: string | undefined;
    externalSysRecordId?: string | undefined;
    rangeUnits?: number | undefined;
    servCode?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date;

    constructor(data?: IAuthorizationExpiryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authId = _data["authId"];
            this.participantPersonId = _data["participantPersonId"];
            this.externalSysRecordId = _data["externalSysRecordId"];
            this.rangeUnits = _data["rangeUnits"];
            this.servCode = _data["servCode"];
            this.serviceStartDate = _data["serviceStartDate"] ? new Date(_data["serviceStartDate"].toString()) : <any>undefined;
            this.serviceEndDate = _data["serviceEndDate"] ? new Date(_data["serviceEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthorizationExpiryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationExpiryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authId"] = this.authId;
        data["participantPersonId"] = this.participantPersonId;
        data["externalSysRecordId"] = this.externalSysRecordId;
        data["rangeUnits"] = this.rangeUnits;
        data["servCode"] = this.servCode;
        data["serviceStartDate"] = this.serviceStartDate ? this.serviceStartDate.toISOString() : <any>undefined;
        data["serviceEndDate"] = this.serviceEndDate ? this.serviceEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthorizationExpiryResponse {
    authId?: string | undefined;
    participantPersonId?: string | undefined;
    externalSysRecordId?: string | undefined;
    rangeUnits?: number | undefined;
    servCode?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date;
}

export class AuthorizationGridResponseBase implements IAuthorizationGridResponseBase {
    items?: Authorization[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: Authorization;

    constructor(data?: IAuthorizationGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Authorization.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? Authorization.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthorizationGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuthorizationGridResponseBase {
    items?: Authorization[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: Authorization;
}

export class AuthorizationSearchRequest implements IAuthorizationSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    clientId?: string | undefined;
    clientName?: string | undefined;
    solomonId?: string | undefined;
    dob?: Date | undefined;
    insuredId?: string | undefined;
    status?: string | undefined;

    constructor(data?: IAuthorizationSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.solomonId = _data["solomonId"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.insuredId = _data["insuredId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AuthorizationSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["solomonId"] = this.solomonId;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["insuredId"] = this.insuredId;
        data["status"] = this.status;
        return data;
    }
}

export interface IAuthorizationSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    clientId?: string | undefined;
    clientName?: string | undefined;
    solomonId?: string | undefined;
    dob?: Date | undefined;
    insuredId?: string | undefined;
    status?: string | undefined;
}

export class AuthorizationStartResponse implements IAuthorizationStartResponse {
    authId?: string | undefined;
    participantPersonId?: string | undefined;
    externalSysRecordId?: string | undefined;
    rangeUnits?: number | undefined;
    servCode?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date;

    constructor(data?: IAuthorizationStartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authId = _data["authId"];
            this.participantPersonId = _data["participantPersonId"];
            this.externalSysRecordId = _data["externalSysRecordId"];
            this.rangeUnits = _data["rangeUnits"];
            this.servCode = _data["servCode"];
            this.serviceStartDate = _data["serviceStartDate"] ? new Date(_data["serviceStartDate"].toString()) : <any>undefined;
            this.serviceEndDate = _data["serviceEndDate"] ? new Date(_data["serviceEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthorizationStartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationStartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authId"] = this.authId;
        data["participantPersonId"] = this.participantPersonId;
        data["externalSysRecordId"] = this.externalSysRecordId;
        data["rangeUnits"] = this.rangeUnits;
        data["servCode"] = this.servCode;
        data["serviceStartDate"] = this.serviceStartDate ? this.serviceStartDate.toISOString() : <any>undefined;
        data["serviceEndDate"] = this.serviceEndDate ? this.serviceEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthorizationStartResponse {
    authId?: string | undefined;
    participantPersonId?: string | undefined;
    externalSysRecordId?: string | undefined;
    rangeUnits?: number | undefined;
    servCode?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date;
}

export enum AuthorizationStatus {
    OnHold = "OnHold",
    Active = "Active",
    Inactive = "Inactive",
    Draft = "Draft",
}

export class AuthorizationSubUtilizationPeriodsResponse implements IAuthorizationSubUtilizationPeriodsResponse {
    serviceCodeUsageLimitId?: number;
    serviceCodeId?: number;
    serviceCode?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    amount?: number;
    isActive?: boolean;
    authType?: AuthType;
    authGroupId?: number | undefined;
    relationshipType?: UsageLimitRelationshipType;

    constructor(data?: IAuthorizationSubUtilizationPeriodsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCodeUsageLimitId = _data["serviceCodeUsageLimitId"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.serviceCode = _data["serviceCode"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.isActive = _data["isActive"];
            this.authType = _data["authType"];
            this.authGroupId = _data["authGroupId"];
            this.relationshipType = _data["relationshipType"];
        }
    }

    static fromJS(data: any): AuthorizationSubUtilizationPeriodsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationSubUtilizationPeriodsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCodeUsageLimitId"] = this.serviceCodeUsageLimitId;
        data["serviceCodeId"] = this.serviceCodeId;
        data["serviceCode"] = this.serviceCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["isActive"] = this.isActive;
        data["authType"] = this.authType;
        data["authGroupId"] = this.authGroupId;
        data["relationshipType"] = this.relationshipType;
        return data;
    }
}

export interface IAuthorizationSubUtilizationPeriodsResponse {
    serviceCodeUsageLimitId?: number;
    serviceCodeId?: number;
    serviceCode?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    amount?: number;
    isActive?: boolean;
    authType?: AuthType;
    authGroupId?: number | undefined;
    relationshipType?: UsageLimitRelationshipType;
}

export class AutoAuthAllocationRequest implements IAutoAuthAllocationRequest {
    participantId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IAutoAuthAllocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AutoAuthAllocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AutoAuthAllocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAutoAuthAllocationRequest {
    participantId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class BillingRecordsRequestDto implements IBillingRecordsRequestDto {
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    servCode?: string | undefined;
    inTime?: Date;
    outTime?: Date;
    progNbr?: string | undefined;
    docType?: string | undefined;
    companyCode?: string | undefined;

    constructor(data?: IBillingRecordsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.servCode = _data["servCode"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.progNbr = _data["progNbr"];
            this.docType = _data["docType"];
            this.companyCode = _data["companyCode"];
        }
    }

    static fromJS(data: any): BillingRecordsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingRecordsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["servCode"] = this.servCode;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["progNbr"] = this.progNbr;
        data["docType"] = this.docType;
        data["companyCode"] = this.companyCode;
        return data;
    }
}

export interface IBillingRecordsRequestDto {
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    servCode?: string | undefined;
    inTime?: Date;
    outTime?: Date;
    progNbr?: string | undefined;
    docType?: string | undefined;
    companyCode?: string | undefined;
}

export class BillingRecordsResponseDto implements IBillingRecordsResponseDto {
    participantId?: string | undefined;
    diagCode?: string | undefined;
    nonBillable?: string | undefined;
    billRate?: number;
    billUnits?: number;
    payUnits?: number;
    markUpPC?: number;
    markup?: number;
    billCodeId?: string | undefined;
    insuredId?: string | undefined;
    programCode?: string | undefined;
    payorCode?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    servCode?: string | undefined;
    beginDate?: Date;
    endDate?: Date;
    unitMethod?: number | undefined;
    unitMulti?: number;
    maxBillRate?: number | undefined;
    authReqd?: boolean;
    placeOfService?: number;
    acn?: string | undefined;
    authCode?: string | undefined;
    status?: string | undefined;
    authStatus?: string[] | undefined;
    detailsStatus?: string | undefined;
    authDetailsStatus?: string[] | undefined;
    payDate?: Date | undefined;
    attendingProviderNumber?: string | undefined;
    referringProviderNumber?: string | undefined;
    passportId?: string | undefined;
    companyId?: number;
    isBillable?: string | undefined;

    constructor(data?: IBillingRecordsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.diagCode = _data["diagCode"];
            this.nonBillable = _data["nonBillable"];
            this.billRate = _data["billRate"];
            this.billUnits = _data["billUnits"];
            this.payUnits = _data["payUnits"];
            this.markUpPC = _data["markUpPC"];
            this.markup = _data["markup"];
            this.billCodeId = _data["billCodeId"];
            this.insuredId = _data["insuredId"];
            this.programCode = _data["programCode"];
            this.payorCode = _data["payorCode"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.servCode = _data["servCode"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.unitMethod = _data["unitMethod"];
            this.unitMulti = _data["unitMulti"];
            this.maxBillRate = _data["maxBillRate"];
            this.authReqd = _data["authReqd"];
            this.placeOfService = _data["placeOfService"];
            this.acn = _data["acn"];
            this.authCode = _data["authCode"];
            this.status = _data["status"];
            if (Array.isArray(_data["authStatus"])) {
                this.authStatus = [] as any;
                for (let item of _data["authStatus"])
                    this.authStatus!.push(item);
            }
            this.detailsStatus = _data["detailsStatus"];
            if (Array.isArray(_data["authDetailsStatus"])) {
                this.authDetailsStatus = [] as any;
                for (let item of _data["authDetailsStatus"])
                    this.authDetailsStatus!.push(item);
            }
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.attendingProviderNumber = _data["attendingProviderNumber"];
            this.referringProviderNumber = _data["referringProviderNumber"];
            this.passportId = _data["passportId"];
            this.companyId = _data["companyId"];
            this.isBillable = _data["isBillable"];
        }
    }

    static fromJS(data: any): BillingRecordsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingRecordsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["diagCode"] = this.diagCode;
        data["nonBillable"] = this.nonBillable;
        data["billRate"] = this.billRate;
        data["billUnits"] = this.billUnits;
        data["payUnits"] = this.payUnits;
        data["markUpPC"] = this.markUpPC;
        data["markup"] = this.markup;
        data["billCodeId"] = this.billCodeId;
        data["insuredId"] = this.insuredId;
        data["programCode"] = this.programCode;
        data["payorCode"] = this.payorCode;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["servCode"] = this.servCode;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["unitMethod"] = this.unitMethod;
        data["unitMulti"] = this.unitMulti;
        data["maxBillRate"] = this.maxBillRate;
        data["authReqd"] = this.authReqd;
        data["placeOfService"] = this.placeOfService;
        data["acn"] = this.acn;
        data["authCode"] = this.authCode;
        data["status"] = this.status;
        if (Array.isArray(this.authStatus)) {
            data["authStatus"] = [];
            for (let item of this.authStatus)
                data["authStatus"].push(item);
        }
        data["detailsStatus"] = this.detailsStatus;
        if (Array.isArray(this.authDetailsStatus)) {
            data["authDetailsStatus"] = [];
            for (let item of this.authDetailsStatus)
                data["authDetailsStatus"].push(item);
        }
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["attendingProviderNumber"] = this.attendingProviderNumber;
        data["referringProviderNumber"] = this.referringProviderNumber;
        data["passportId"] = this.passportId;
        data["companyId"] = this.companyId;
        data["isBillable"] = this.isBillable;
        return data;
    }
}

export interface IBillingRecordsResponseDto {
    participantId?: string | undefined;
    diagCode?: string | undefined;
    nonBillable?: string | undefined;
    billRate?: number;
    billUnits?: number;
    payUnits?: number;
    markUpPC?: number;
    markup?: number;
    billCodeId?: string | undefined;
    insuredId?: string | undefined;
    programCode?: string | undefined;
    payorCode?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    servCode?: string | undefined;
    beginDate?: Date;
    endDate?: Date;
    unitMethod?: number | undefined;
    unitMulti?: number;
    maxBillRate?: number | undefined;
    authReqd?: boolean;
    placeOfService?: number;
    acn?: string | undefined;
    authCode?: string | undefined;
    status?: string | undefined;
    authStatus?: string[] | undefined;
    detailsStatus?: string | undefined;
    authDetailsStatus?: string[] | undefined;
    payDate?: Date | undefined;
    attendingProviderNumber?: string | undefined;
    referringProviderNumber?: string | undefined;
    passportId?: string | undefined;
    companyId?: number;
    isBillable?: string | undefined;
}

export class BooleanApiResponse implements IBooleanApiResponse {
    message?: string | undefined;
    data?: boolean;
    success?: boolean;

    constructor(data?: IBooleanApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.data = _data["data"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): BooleanApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["data"] = this.data;
        data["success"] = this.success;
        return data;
    }
}

export interface IBooleanApiResponse {
    message?: string | undefined;
    data?: boolean;
    success?: boolean;
}

export class BudgetSummary implements IBudgetSummary {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    id?: number | undefined;
    authCode?: string | undefined;
    servCodeId?: number | undefined;
    servCode?: string | undefined;
    servDescription?: string | undefined;
    displayValue?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    feePctPr?: number | undefined;
    feePctAdmin?: number | undefined;
    pmFee?: boolean | undefined;
    hours?: number | undefined;
    units?: number | undefined;
    rangeUnits?: number | undefined;
    budgetAmt?: number | undefined;
    rangeAmt?: number | undefined;
    unitRange?: number | undefined;
    amtRange?: number | undefined;
    acn?: string | undefined;
    status?: AuthorizationStatus;
    closeOverlappingServices?: boolean | undefined;
    range?: string | undefined;
    serviceType?: string | undefined;
    waiverCodes?: AuthDetailWaiverCode[] | undefined;
    updated?: boolean | undefined;
    isDraft?: boolean;
    programNumber?: string | undefined;
    agreementNumber?: string | undefined;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    clientStatus?: string | undefined;
    authStatus?: string | undefined;
    diagCode?: string | undefined;
    authDetailsStatus?: string[] | undefined;
    currentAuthDetailsStatus?: string[] | undefined;
    waiverCodeIdsList?: number[] | undefined;
    externalSysRecordId?: string | undefined;
    autoRenewal?: boolean;
    correlationId?: string | undefined;
    authNotes?: NoteDto[] | undefined;

    constructor(data?: IBudgetSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.authCode = _data["authCode"];
            this.servCodeId = _data["servCodeId"];
            this.servCode = _data["servCode"];
            this.servDescription = _data["servDescription"];
            this.displayValue = _data["displayValue"];
            this.serviceStartDate = _data["serviceStartDate"] ? new Date(_data["serviceStartDate"].toString()) : <any>undefined;
            this.serviceEndDate = _data["serviceEndDate"] ? new Date(_data["serviceEndDate"].toString()) : <any>undefined;
            this.feePctPr = _data["feePctPr"];
            this.feePctAdmin = _data["feePctAdmin"];
            this.pmFee = _data["pmFee"];
            this.hours = _data["hours"];
            this.units = _data["units"];
            this.rangeUnits = _data["rangeUnits"];
            this.budgetAmt = _data["budgetAmt"];
            this.rangeAmt = _data["rangeAmt"];
            this.unitRange = _data["unitRange"];
            this.amtRange = _data["amtRange"];
            this.acn = _data["acn"];
            this.status = _data["status"];
            this.closeOverlappingServices = _data["closeOverlappingServices"];
            this.range = _data["range"];
            this.serviceType = _data["serviceType"];
            if (Array.isArray(_data["waiverCodes"])) {
                this.waiverCodes = [] as any;
                for (let item of _data["waiverCodes"])
                    this.waiverCodes!.push(AuthDetailWaiverCode.fromJS(item));
            }
            this.updated = _data["updated"];
            this.isDraft = _data["isDraft"];
            this.programNumber = _data["programNumber"];
            this.agreementNumber = _data["agreementNumber"];
            this.authStartDate = _data["authStartDate"] ? new Date(_data["authStartDate"].toString()) : <any>undefined;
            this.authEndDate = _data["authEndDate"] ? new Date(_data["authEndDate"].toString()) : <any>undefined;
            this.clientStatus = _data["clientStatus"];
            this.authStatus = _data["authStatus"];
            this.diagCode = _data["diagCode"];
            if (Array.isArray(_data["authDetailsStatus"])) {
                this.authDetailsStatus = [] as any;
                for (let item of _data["authDetailsStatus"])
                    this.authDetailsStatus!.push(item);
            }
            if (Array.isArray(_data["currentAuthDetailsStatus"])) {
                this.currentAuthDetailsStatus = [] as any;
                for (let item of _data["currentAuthDetailsStatus"])
                    this.currentAuthDetailsStatus!.push(item);
            }
            if (Array.isArray(_data["waiverCodeIdsList"])) {
                this.waiverCodeIdsList = [] as any;
                for (let item of _data["waiverCodeIdsList"])
                    this.waiverCodeIdsList!.push(item);
            }
            this.externalSysRecordId = _data["externalSysRecordId"];
            this.autoRenewal = _data["autoRenewal"];
            this.correlationId = _data["correlationId"];
            if (Array.isArray(_data["authNotes"])) {
                this.authNotes = [] as any;
                for (let item of _data["authNotes"])
                    this.authNotes!.push(NoteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetSummary {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["authCode"] = this.authCode;
        data["servCodeId"] = this.servCodeId;
        data["servCode"] = this.servCode;
        data["servDescription"] = this.servDescription;
        data["displayValue"] = this.displayValue;
        data["serviceStartDate"] = this.serviceStartDate ? this.serviceStartDate.toISOString() : <any>undefined;
        data["serviceEndDate"] = this.serviceEndDate ? this.serviceEndDate.toISOString() : <any>undefined;
        data["feePctPr"] = this.feePctPr;
        data["feePctAdmin"] = this.feePctAdmin;
        data["pmFee"] = this.pmFee;
        data["hours"] = this.hours;
        data["units"] = this.units;
        data["rangeUnits"] = this.rangeUnits;
        data["budgetAmt"] = this.budgetAmt;
        data["rangeAmt"] = this.rangeAmt;
        data["unitRange"] = this.unitRange;
        data["amtRange"] = this.amtRange;
        data["acn"] = this.acn;
        data["status"] = this.status;
        data["closeOverlappingServices"] = this.closeOverlappingServices;
        data["range"] = this.range;
        data["serviceType"] = this.serviceType;
        if (Array.isArray(this.waiverCodes)) {
            data["waiverCodes"] = [];
            for (let item of this.waiverCodes)
                data["waiverCodes"].push(item.toJSON());
        }
        data["updated"] = this.updated;
        data["isDraft"] = this.isDraft;
        data["programNumber"] = this.programNumber;
        data["agreementNumber"] = this.agreementNumber;
        data["authStartDate"] = this.authStartDate ? this.authStartDate.toISOString() : <any>undefined;
        data["authEndDate"] = this.authEndDate ? this.authEndDate.toISOString() : <any>undefined;
        data["clientStatus"] = this.clientStatus;
        data["authStatus"] = this.authStatus;
        data["diagCode"] = this.diagCode;
        if (Array.isArray(this.authDetailsStatus)) {
            data["authDetailsStatus"] = [];
            for (let item of this.authDetailsStatus)
                data["authDetailsStatus"].push(item);
        }
        if (Array.isArray(this.currentAuthDetailsStatus)) {
            data["currentAuthDetailsStatus"] = [];
            for (let item of this.currentAuthDetailsStatus)
                data["currentAuthDetailsStatus"].push(item);
        }
        if (Array.isArray(this.waiverCodeIdsList)) {
            data["waiverCodeIdsList"] = [];
            for (let item of this.waiverCodeIdsList)
                data["waiverCodeIdsList"].push(item);
        }
        data["externalSysRecordId"] = this.externalSysRecordId;
        data["autoRenewal"] = this.autoRenewal;
        data["correlationId"] = this.correlationId;
        if (Array.isArray(this.authNotes)) {
            data["authNotes"] = [];
            for (let item of this.authNotes)
                data["authNotes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBudgetSummary {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    id?: number | undefined;
    authCode?: string | undefined;
    servCodeId?: number | undefined;
    servCode?: string | undefined;
    servDescription?: string | undefined;
    displayValue?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    feePctPr?: number | undefined;
    feePctAdmin?: number | undefined;
    pmFee?: boolean | undefined;
    hours?: number | undefined;
    units?: number | undefined;
    rangeUnits?: number | undefined;
    budgetAmt?: number | undefined;
    rangeAmt?: number | undefined;
    unitRange?: number | undefined;
    amtRange?: number | undefined;
    acn?: string | undefined;
    status?: AuthorizationStatus;
    closeOverlappingServices?: boolean | undefined;
    range?: string | undefined;
    serviceType?: string | undefined;
    waiverCodes?: AuthDetailWaiverCode[] | undefined;
    updated?: boolean | undefined;
    isDraft?: boolean;
    programNumber?: string | undefined;
    agreementNumber?: string | undefined;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    clientStatus?: string | undefined;
    authStatus?: string | undefined;
    diagCode?: string | undefined;
    authDetailsStatus?: string[] | undefined;
    currentAuthDetailsStatus?: string[] | undefined;
    waiverCodeIdsList?: number[] | undefined;
    externalSysRecordId?: string | undefined;
    autoRenewal?: boolean;
    correlationId?: string | undefined;
    authNotes?: NoteDto[] | undefined;
}

export class BudgetSummaryHistory implements IBudgetSummaryHistory {
    updateDate?: Date | undefined;
    serviceCode?: string | undefined;
    description?: string | undefined;
    authorizationNumber?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    serviceType?: string | undefined;
    diagCode?: string | undefined;
    hours?: number | undefined;
    totalUnits?: number | undefined;
    rangeUnits?: number | undefined;
    unitRange?: string | undefined;
    budgetAmount?: number | undefined;
    rangeAmount?: number | undefined;
    amountRange?: string | undefined;
    pmFee?: boolean | undefined;
    feePCTAdmin?: number | undefined;
    feePCTPR?: number | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    authDetailsId?: number;

    constructor(data?: IBudgetSummaryHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.serviceCode = _data["serviceCode"];
            this.description = _data["description"];
            this.authorizationNumber = _data["authorizationNumber"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.serviceType = _data["serviceType"];
            this.diagCode = _data["diagCode"];
            this.hours = _data["hours"];
            this.totalUnits = _data["totalUnits"];
            this.rangeUnits = _data["rangeUnits"];
            this.unitRange = _data["unitRange"];
            this.budgetAmount = _data["budgetAmount"];
            this.rangeAmount = _data["rangeAmount"];
            this.amountRange = _data["amountRange"];
            this.pmFee = _data["pmFee"];
            this.feePCTAdmin = _data["feePCTAdmin"];
            this.feePCTPR = _data["feePCTPR"];
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.authDetailsId = _data["authDetailsId"];
        }
    }

    static fromJS(data: any): BudgetSummaryHistory {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetSummaryHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["serviceCode"] = this.serviceCode;
        data["description"] = this.description;
        data["authorizationNumber"] = this.authorizationNumber;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["serviceType"] = this.serviceType;
        data["diagCode"] = this.diagCode;
        data["hours"] = this.hours;
        data["totalUnits"] = this.totalUnits;
        data["rangeUnits"] = this.rangeUnits;
        data["unitRange"] = this.unitRange;
        data["budgetAmount"] = this.budgetAmount;
        data["rangeAmount"] = this.rangeAmount;
        data["amountRange"] = this.amountRange;
        data["pmFee"] = this.pmFee;
        data["feePCTAdmin"] = this.feePCTAdmin;
        data["feePCTPR"] = this.feePCTPR;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["authDetailsId"] = this.authDetailsId;
        return data;
    }
}

export interface IBudgetSummaryHistory {
    updateDate?: Date | undefined;
    serviceCode?: string | undefined;
    description?: string | undefined;
    authorizationNumber?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    serviceType?: string | undefined;
    diagCode?: string | undefined;
    hours?: number | undefined;
    totalUnits?: number | undefined;
    rangeUnits?: number | undefined;
    unitRange?: string | undefined;
    budgetAmount?: number | undefined;
    rangeAmount?: number | undefined;
    amountRange?: string | undefined;
    pmFee?: boolean | undefined;
    feePCTAdmin?: number | undefined;
    feePCTPR?: number | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    authDetailsId?: number;
}

export class BudgetSummaryHistoryGridResponseBase implements IBudgetSummaryHistoryGridResponseBase {
    items?: BudgetSummaryHistory[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BudgetSummaryHistory;

    constructor(data?: IBudgetSummaryHistoryGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BudgetSummaryHistory.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? BudgetSummaryHistory.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BudgetSummaryHistoryGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetSummaryHistoryGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBudgetSummaryHistoryGridResponseBase {
    items?: BudgetSummaryHistory[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BudgetSummaryHistory;
}

export class CareGiverPtoDetails implements ICareGiverPtoDetails {
    units?: number;

    constructor(data?: ICareGiverPtoDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.units = _data["units"];
        }
    }

    static fromJS(data: any): CareGiverPtoDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CareGiverPtoDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["units"] = this.units;
        return data;
    }
}

export interface ICareGiverPtoDetails {
    units?: number;
}

export class CaregiverParticipantAuthAllocationDetail implements ICaregiverParticipantAuthAllocationDetail {
    serviceCode?: string | undefined;
    serviceCodeDescription?: string | undefined;
    serviceCodeId?: number;
    serviceTypeDisplay?: string | undefined;
    allocatedHours?: number;
    billedHours?: number;
    readonly remainingHours?: number;

    constructor(data?: ICaregiverParticipantAuthAllocationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCode = _data["serviceCode"];
            this.serviceCodeDescription = _data["serviceCodeDescription"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.serviceTypeDisplay = _data["serviceTypeDisplay"];
            this.allocatedHours = _data["allocatedHours"];
            this.billedHours = _data["billedHours"];
            (<any>this).remainingHours = _data["remainingHours"];
        }
    }

    static fromJS(data: any): CaregiverParticipantAuthAllocationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantAuthAllocationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCode"] = this.serviceCode;
        data["serviceCodeDescription"] = this.serviceCodeDescription;
        data["serviceCodeId"] = this.serviceCodeId;
        data["serviceTypeDisplay"] = this.serviceTypeDisplay;
        data["allocatedHours"] = this.allocatedHours;
        data["billedHours"] = this.billedHours;
        data["remainingHours"] = this.remainingHours;
        return data;
    }
}

export interface ICaregiverParticipantAuthAllocationDetail {
    serviceCode?: string | undefined;
    serviceCodeDescription?: string | undefined;
    serviceCodeId?: number;
    serviceTypeDisplay?: string | undefined;
    allocatedHours?: number;
    billedHours?: number;
    remainingHours?: number;
}

export class CaregiverShiftHoursRequest implements ICaregiverShiftHoursRequest {
    caregiverPersonId?: string | undefined;
    serviceDate?: Date;

    constructor(data?: ICaregiverShiftHoursRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverShiftHoursRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverShiftHoursRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaregiverShiftHoursRequest {
    caregiverPersonId?: string | undefined;
    serviceDate?: Date;
}

export class CaregiverShiftHoursResponse implements ICaregiverShiftHoursResponse {
    hours?: number | undefined;

    constructor(data?: ICaregiverShiftHoursResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): CaregiverShiftHoursResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverShiftHoursResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hours"] = this.hours;
        return data;
    }
}

export interface ICaregiverShiftHoursResponse {
    hours?: number | undefined;
}

export class CaregiverWeeklyAllocationsRequest implements ICaregiverWeeklyAllocationsRequest {
    serviceCode?: string[] | undefined;
    caregiverPersonId?: string | undefined;
    participantPersonId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: ICaregiverWeeklyAllocationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceCode"])) {
                this.serviceCode = [] as any;
                for (let item of _data["serviceCode"])
                    this.serviceCode!.push(item);
            }
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.participantPersonId = _data["participantPersonId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverWeeklyAllocationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWeeklyAllocationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceCode)) {
            data["serviceCode"] = [];
            for (let item of this.serviceCode)
                data["serviceCode"].push(item);
        }
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["participantPersonId"] = this.participantPersonId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaregiverWeeklyAllocationsRequest {
    serviceCode?: string[] | undefined;
    caregiverPersonId?: string | undefined;
    participantPersonId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class CaregiverWeeklyAllocationsResponse implements ICaregiverWeeklyAllocationsResponse {
    serviceCode?: string | undefined;
    authAllocationEnabled?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    allocatedUnits?: number | undefined;

    constructor(data?: ICaregiverWeeklyAllocationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCode = _data["serviceCode"];
            this.authAllocationEnabled = _data["authAllocationEnabled"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.allocatedUnits = _data["allocatedUnits"];
        }
    }

    static fromJS(data: any): CaregiverWeeklyAllocationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWeeklyAllocationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCode"] = this.serviceCode;
        data["authAllocationEnabled"] = this.authAllocationEnabled;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["allocatedUnits"] = this.allocatedUnits;
        return data;
    }
}

export interface ICaregiverWeeklyAllocationsResponse {
    serviceCode?: string | undefined;
    authAllocationEnabled?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    allocatedUnits?: number | undefined;
}

export class CaregiverWeeklyHoursRequest implements ICaregiverWeeklyHoursRequest {
    employerIds?: number[] | undefined;
    caregiverPersonId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: ICaregiverWeeklyHoursRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employerIds"])) {
                this.employerIds = [] as any;
                for (let item of _data["employerIds"])
                    this.employerIds!.push(item);
            }
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverWeeklyHoursRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWeeklyHoursRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employerIds)) {
            data["employerIds"] = [];
            for (let item of this.employerIds)
                data["employerIds"].push(item);
        }
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaregiverWeeklyHoursRequest {
    employerIds?: number[] | undefined;
    caregiverPersonId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class CaregiverWeeklyHoursResponse implements ICaregiverWeeklyHoursResponse {
    employerId?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    aggregateCalHrs?: number | undefined;

    constructor(data?: ICaregiverWeeklyHoursResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerId = _data["employerId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.aggregateCalHrs = _data["aggregateCalHrs"];
        }
    }

    static fromJS(data: any): CaregiverWeeklyHoursResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWeeklyHoursResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerId"] = this.employerId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["aggregateCalHrs"] = this.aggregateCalHrs;
        return data;
    }
}

export interface ICaregiverWeeklyHoursResponse {
    employerId?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    aggregateCalHrs?: number | undefined;
}

export class CaregiverWeeklyTotalAllocations implements ICaregiverWeeklyTotalAllocations {
    caregiverId?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalAllocatedHours?: number | undefined;

    constructor(data?: ICaregiverWeeklyTotalAllocations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.totalAllocatedHours = _data["totalAllocatedHours"];
        }
    }

    static fromJS(data: any): CaregiverWeeklyTotalAllocations {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWeeklyTotalAllocations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["totalAllocatedHours"] = this.totalAllocatedHours;
        return data;
    }
}

export interface ICaregiverWeeklyTotalAllocations {
    caregiverId?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalAllocatedHours?: number | undefined;
}

export class CaregiverWeeklyTotalHours implements ICaregiverWeeklyTotalHours {
    caregiverId?: number;
    startDate?: Date;
    endDate?: Date;
    totalHoursWorked?: number;

    constructor(data?: ICaregiverWeeklyTotalHours) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.totalHoursWorked = _data["totalHoursWorked"];
        }
    }

    static fromJS(data: any): CaregiverWeeklyTotalHours {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWeeklyTotalHours();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["totalHoursWorked"] = this.totalHoursWorked;
        return data;
    }
}

export interface ICaregiverWeeklyTotalHours {
    caregiverId?: number;
    startDate?: Date;
    endDate?: Date;
    totalHoursWorked?: number;
}

export class CaregiverWeeklyUnitsHolder implements ICaregiverWeeklyUnitsHolder {
    caregiverWeeklyUnits?: CaregiverWeeklyUnitsResponse[] | undefined;
    caregiverWeeklyAllocations?: CaregiverWeeklyTotalAllocations[] | undefined;
    caregiverWeeklyHours?: CaregiverWeeklyTotalHours[] | undefined;

    constructor(data?: ICaregiverWeeklyUnitsHolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caregiverWeeklyUnits"])) {
                this.caregiverWeeklyUnits = [] as any;
                for (let item of _data["caregiverWeeklyUnits"])
                    this.caregiverWeeklyUnits!.push(CaregiverWeeklyUnitsResponse.fromJS(item));
            }
            if (Array.isArray(_data["caregiverWeeklyAllocations"])) {
                this.caregiverWeeklyAllocations = [] as any;
                for (let item of _data["caregiverWeeklyAllocations"])
                    this.caregiverWeeklyAllocations!.push(CaregiverWeeklyTotalAllocations.fromJS(item));
            }
            if (Array.isArray(_data["caregiverWeeklyHours"])) {
                this.caregiverWeeklyHours = [] as any;
                for (let item of _data["caregiverWeeklyHours"])
                    this.caregiverWeeklyHours!.push(CaregiverWeeklyTotalHours.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverWeeklyUnitsHolder {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWeeklyUnitsHolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caregiverWeeklyUnits)) {
            data["caregiverWeeklyUnits"] = [];
            for (let item of this.caregiverWeeklyUnits)
                data["caregiverWeeklyUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.caregiverWeeklyAllocations)) {
            data["caregiverWeeklyAllocations"] = [];
            for (let item of this.caregiverWeeklyAllocations)
                data["caregiverWeeklyAllocations"].push(item.toJSON());
        }
        if (Array.isArray(this.caregiverWeeklyHours)) {
            data["caregiverWeeklyHours"] = [];
            for (let item of this.caregiverWeeklyHours)
                data["caregiverWeeklyHours"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverWeeklyUnitsHolder {
    caregiverWeeklyUnits?: CaregiverWeeklyUnitsResponse[] | undefined;
    caregiverWeeklyAllocations?: CaregiverWeeklyTotalAllocations[] | undefined;
    caregiverWeeklyHours?: CaregiverWeeklyTotalHours[] | undefined;
}

export class CaregiverWeeklyUnitsRequest implements ICaregiverWeeklyUnitsRequest {
    serviceCode?: string[] | undefined;
    caregiverPersonId?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    participantPersonId?: string | undefined;
    updaterToIgnore?: string | undefined;

    constructor(data?: ICaregiverWeeklyUnitsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceCode"])) {
                this.serviceCode = [] as any;
                for (let item of _data["serviceCode"])
                    this.serviceCode!.push(item);
            }
            if (Array.isArray(_data["caregiverPersonId"])) {
                this.caregiverPersonId = [] as any;
                for (let item of _data["caregiverPersonId"])
                    this.caregiverPersonId!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.participantPersonId = _data["participantPersonId"];
            this.updaterToIgnore = _data["updaterToIgnore"];
        }
    }

    static fromJS(data: any): CaregiverWeeklyUnitsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWeeklyUnitsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceCode)) {
            data["serviceCode"] = [];
            for (let item of this.serviceCode)
                data["serviceCode"].push(item);
        }
        if (Array.isArray(this.caregiverPersonId)) {
            data["caregiverPersonId"] = [];
            for (let item of this.caregiverPersonId)
                data["caregiverPersonId"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["participantPersonId"] = this.participantPersonId;
        data["updaterToIgnore"] = this.updaterToIgnore;
        return data;
    }
}

export interface ICaregiverWeeklyUnitsRequest {
    serviceCode?: string[] | undefined;
    caregiverPersonId?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    participantPersonId?: string | undefined;
    updaterToIgnore?: string | undefined;
}

export class CaregiverWeeklyUnitsResponse implements ICaregiverWeeklyUnitsResponse {
    serviceCode?: string | undefined;
    authAllocationEnabled?: boolean;
    caregiverPersonId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    aggregateUnits?: number | undefined;

    constructor(data?: ICaregiverWeeklyUnitsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCode = _data["serviceCode"];
            this.authAllocationEnabled = _data["authAllocationEnabled"];
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.aggregateUnits = _data["aggregateUnits"];
        }
    }

    static fromJS(data: any): CaregiverWeeklyUnitsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWeeklyUnitsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCode"] = this.serviceCode;
        data["authAllocationEnabled"] = this.authAllocationEnabled;
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["aggregateUnits"] = this.aggregateUnits;
        return data;
    }
}

export interface ICaregiverWeeklyUnitsResponse {
    serviceCode?: string | undefined;
    authAllocationEnabled?: boolean;
    caregiverPersonId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    aggregateUnits?: number | undefined;
}

export class ColumnLevelChangeHistoryBase implements IColumnLevelChangeHistoryBase {
    previousColumnValue?: string | undefined;
    currentColumnValue?: string | undefined;
    columnName?: string | undefined;

    constructor(data?: IColumnLevelChangeHistoryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousColumnValue = _data["previousColumnValue"];
            this.currentColumnValue = _data["currentColumnValue"];
            this.columnName = _data["columnName"];
        }
    }

    static fromJS(data: any): ColumnLevelChangeHistoryBase {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnLevelChangeHistoryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousColumnValue"] = this.previousColumnValue;
        data["currentColumnValue"] = this.currentColumnValue;
        data["columnName"] = this.columnName;
        return data;
    }
}

export interface IColumnLevelChangeHistoryBase {
    previousColumnValue?: string | undefined;
    currentColumnValue?: string | undefined;
    columnName?: string | undefined;
}

export class ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase implements IColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase {
    readonly columnLevelChangeHistory?: ColumnLevelChangeHistoryBase[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columnLevelChangeHistory"])) {
                (<any>this).columnLevelChangeHistory = [] as any;
                for (let item of _data["columnLevelChangeHistory"])
                    (<any>this).columnLevelChangeHistory!.push(ColumnLevelChangeHistoryBase.fromJS(item));
            }
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnLevelChangeHistory)) {
            data["columnLevelChangeHistory"] = [];
            for (let item of this.columnLevelChangeHistory)
                data["columnLevelChangeHistory"].push(item.toJSON());
        }
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase {
    columnLevelChangeHistory?: ColumnLevelChangeHistoryBase[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
}

export class CurrentAuthorizationServiceUtilization implements ICurrentAuthorizationServiceUtilization {
    startDate?: Date;
    endDate?: Date;
    ecn?: string | undefined;
    caregiverId?: number | undefined;
    participantId?: number | undefined;
    serviceCodes?: string[] | undefined;
    relationshipType?: UsageLimitRelationshipType;
    authType?: AuthType;
    types?: string[] | undefined;
    subTypes?: string[] | undefined;
    readonly pathAndQueryParameters?: string | undefined;

    constructor(data?: ICurrentAuthorizationServiceUtilization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.ecn = _data["ecn"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            if (Array.isArray(_data["serviceCodes"])) {
                this.serviceCodes = [] as any;
                for (let item of _data["serviceCodes"])
                    this.serviceCodes!.push(item);
            }
            this.relationshipType = _data["relationshipType"];
            this.authType = _data["authType"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            if (Array.isArray(_data["subTypes"])) {
                this.subTypes = [] as any;
                for (let item of _data["subTypes"])
                    this.subTypes!.push(item);
            }
            (<any>this).pathAndQueryParameters = _data["pathAndQueryParameters"];
        }
    }

    static fromJS(data: any): CurrentAuthorizationServiceUtilization {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentAuthorizationServiceUtilization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["ecn"] = this.ecn;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        if (Array.isArray(this.serviceCodes)) {
            data["serviceCodes"] = [];
            for (let item of this.serviceCodes)
                data["serviceCodes"].push(item);
        }
        data["relationshipType"] = this.relationshipType;
        data["authType"] = this.authType;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        if (Array.isArray(this.subTypes)) {
            data["subTypes"] = [];
            for (let item of this.subTypes)
                data["subTypes"].push(item);
        }
        data["pathAndQueryParameters"] = this.pathAndQueryParameters;
        return data;
    }
}

export interface ICurrentAuthorizationServiceUtilization {
    startDate?: Date;
    endDate?: Date;
    ecn?: string | undefined;
    caregiverId?: number | undefined;
    participantId?: number | undefined;
    serviceCodes?: string[] | undefined;
    relationshipType?: UsageLimitRelationshipType;
    authType?: AuthType;
    types?: string[] | undefined;
    subTypes?: string[] | undefined;
    pathAndQueryParameters?: string | undefined;
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export class EventHarvestorRequest implements IEventHarvestorRequest {
    startDate?: Date;
    endDate?: Date;
    companyCode?: string | undefined;
    companyId?: number;

    constructor(data?: IEventHarvestorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.companyCode = _data["companyCode"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): EventHarvestorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EventHarvestorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["companyCode"] = this.companyCode;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IEventHarvestorRequest {
    startDate?: Date;
    endDate?: Date;
    companyCode?: string | undefined;
    companyId?: number;
}

export class FilterRequest implements IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;

    constructor(data?: IFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): FilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
}

export class GetHistoryRequestBase implements IGetHistoryRequestBase {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    explicitColumns?: string[] | undefined;
    includeCreation?: boolean;

    constructor(data?: IGetHistoryRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["explicitColumns"])) {
                this.explicitColumns = [] as any;
                for (let item of _data["explicitColumns"])
                    this.explicitColumns!.push(item);
            }
            this.includeCreation = _data["includeCreation"];
        }
    }

    static fromJS(data: any): GetHistoryRequestBase {
        data = typeof data === 'object' ? data : {};
        let result = new GetHistoryRequestBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.explicitColumns)) {
            data["explicitColumns"] = [];
            for (let item of this.explicitColumns)
                data["explicitColumns"].push(item);
        }
        data["includeCreation"] = this.includeCreation;
        return data;
    }
}

export interface IGetHistoryRequestBase {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    explicitColumns?: string[] | undefined;
    includeCreation?: boolean;
}

export class InsuredIdRequest implements IInsuredIdRequest {
    participantId?: number;
    programId?: number;

    constructor(data?: IInsuredIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.programId = _data["programId"];
        }
    }

    static fromJS(data: any): InsuredIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuredIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["programId"] = this.programId;
        return data;
    }
}

export interface IInsuredIdRequest {
    participantId?: number;
    programId?: number;
}

export class InternalAuthLedgerRequest implements IInternalAuthLedgerRequest {
    caregiverId?: number;
    caregiverName?: string | undefined;
    employerId?: number;
    employerName?: string | undefined;
    serviceCode?: string | undefined;
    serviceCodeWithDesc?: string | undefined;
    pageNum?: number;
    sortDescending?: boolean;
    companyId?: number;
    companyCode?: string | undefined;
    userEmail?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IInternalAuthLedgerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.caregiverName = _data["caregiverName"];
            this.employerId = _data["employerId"];
            this.employerName = _data["employerName"];
            this.serviceCode = _data["serviceCode"];
            this.serviceCodeWithDesc = _data["serviceCodeWithDesc"];
            this.pageNum = _data["pageNum"];
            this.sortDescending = _data["sortDescending"];
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.userEmail = _data["userEmail"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InternalAuthLedgerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InternalAuthLedgerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["caregiverName"] = this.caregiverName;
        data["employerId"] = this.employerId;
        data["employerName"] = this.employerName;
        data["serviceCode"] = this.serviceCode;
        data["serviceCodeWithDesc"] = this.serviceCodeWithDesc;
        data["pageNum"] = this.pageNum;
        data["sortDescending"] = this.sortDescending;
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["userEmail"] = this.userEmail;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInternalAuthLedgerRequest {
    caregiverId?: number;
    caregiverName?: string | undefined;
    employerId?: number;
    employerName?: string | undefined;
    serviceCode?: string | undefined;
    serviceCodeWithDesc?: string | undefined;
    pageNum?: number;
    sortDescending?: boolean;
    companyId?: number;
    companyCode?: string | undefined;
    userEmail?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class InternalAuthorizationBalancesDetail implements IInternalAuthorizationBalancesDetail {
    readonly timePeriod?: string | undefined;
    fiscalYearStart?: Date;
    fiscalYearEnd?: Date;
    serviceCode?: string | undefined;
    serviceCodeDescription?: string | undefined;
    balance?: number;
    hoursUsed?: number;
    startDate?: Date;
    endDate?: Date;
    serviceCodeLimit?: number;

    constructor(data?: IInternalAuthorizationBalancesDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).timePeriod = _data["timePeriod"];
            this.fiscalYearStart = _data["fiscalYearStart"] ? new Date(_data["fiscalYearStart"].toString()) : <any>undefined;
            this.fiscalYearEnd = _data["fiscalYearEnd"] ? new Date(_data["fiscalYearEnd"].toString()) : <any>undefined;
            this.serviceCode = _data["serviceCode"];
            this.serviceCodeDescription = _data["serviceCodeDescription"];
            this.balance = _data["balance"];
            this.hoursUsed = _data["hoursUsed"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.serviceCodeLimit = _data["serviceCodeLimit"];
        }
    }

    static fromJS(data: any): InternalAuthorizationBalancesDetail {
        data = typeof data === 'object' ? data : {};
        let result = new InternalAuthorizationBalancesDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timePeriod"] = this.timePeriod;
        data["fiscalYearStart"] = this.fiscalYearStart ? this.fiscalYearStart.toISOString() : <any>undefined;
        data["fiscalYearEnd"] = this.fiscalYearEnd ? this.fiscalYearEnd.toISOString() : <any>undefined;
        data["serviceCode"] = this.serviceCode;
        data["serviceCodeDescription"] = this.serviceCodeDescription;
        data["balance"] = this.balance;
        data["hoursUsed"] = this.hoursUsed;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["serviceCodeLimit"] = this.serviceCodeLimit;
        return data;
    }
}

export interface IInternalAuthorizationBalancesDetail {
    timePeriod?: string | undefined;
    fiscalYearStart?: Date;
    fiscalYearEnd?: Date;
    serviceCode?: string | undefined;
    serviceCodeDescription?: string | undefined;
    balance?: number;
    hoursUsed?: number;
    startDate?: Date;
    endDate?: Date;
    serviceCodeLimit?: number;
}

export class InternalAuthorizationRequest implements IInternalAuthorizationRequest {
    internalAuthorizationId?: number;
    serviceCodeId?: number;
    serviceCodeValue?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    transactionDate?: Date;
    units?: number;
    employerId?: number | undefined;
    isModified?: boolean;

    constructor(data?: IInternalAuthorizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalAuthorizationId = _data["internalAuthorizationId"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.serviceCodeValue = _data["serviceCodeValue"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.units = _data["units"];
            this.employerId = _data["employerId"];
            this.isModified = _data["isModified"];
        }
    }

    static fromJS(data: any): InternalAuthorizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InternalAuthorizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalAuthorizationId"] = this.internalAuthorizationId;
        data["serviceCodeId"] = this.serviceCodeId;
        data["serviceCodeValue"] = this.serviceCodeValue;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["units"] = this.units;
        data["employerId"] = this.employerId;
        data["isModified"] = this.isModified;
        return data;
    }
}

export interface IInternalAuthorizationRequest {
    internalAuthorizationId?: number;
    serviceCodeId?: number;
    serviceCodeValue?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    transactionDate?: Date;
    units?: number;
    employerId?: number | undefined;
    isModified?: boolean;
}

export class InternalAuthorizationRequestList implements IInternalAuthorizationRequestList {
    internalAuthorizationRequests?: InternalAuthorizationRequest[] | undefined;
    caregiverId?: number;

    constructor(data?: IInternalAuthorizationRequestList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["internalAuthorizationRequests"])) {
                this.internalAuthorizationRequests = [] as any;
                for (let item of _data["internalAuthorizationRequests"])
                    this.internalAuthorizationRequests!.push(InternalAuthorizationRequest.fromJS(item));
            }
            this.caregiverId = _data["caregiverId"];
        }
    }

    static fromJS(data: any): InternalAuthorizationRequestList {
        data = typeof data === 'object' ? data : {};
        let result = new InternalAuthorizationRequestList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.internalAuthorizationRequests)) {
            data["internalAuthorizationRequests"] = [];
            for (let item of this.internalAuthorizationRequests)
                data["internalAuthorizationRequests"].push(item.toJSON());
        }
        data["caregiverId"] = this.caregiverId;
        return data;
    }
}

export interface IInternalAuthorizationRequestList {
    internalAuthorizationRequests?: InternalAuthorizationRequest[] | undefined;
    caregiverId?: number;
}

export class InternalAuthorizationResponse implements IInternalAuthorizationResponse {
    internalAuthorizationId?: number;
    companyId?: number;
    serviceCodeId?: number;
    serviceCode?: string | undefined;
    commentsRequiredValue?: number;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    units?: number;
    unitsSatisfied?: number;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    minTransDate?: Date | undefined;
    maxTransDate?: Date | undefined;
    employerId?: number | undefined;
    servCodeAuthType?: number;
    adminAuthSubUtilizationPeriodUnits?: number | undefined;

    constructor(data?: IInternalAuthorizationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalAuthorizationId = _data["internalAuthorizationId"];
            this.companyId = _data["companyId"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.serviceCode = _data["serviceCode"];
            this.commentsRequiredValue = _data["commentsRequiredValue"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.units = _data["units"];
            this.unitsSatisfied = _data["unitsSatisfied"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.minTransDate = _data["minTransDate"] ? new Date(_data["minTransDate"].toString()) : <any>undefined;
            this.maxTransDate = _data["maxTransDate"] ? new Date(_data["maxTransDate"].toString()) : <any>undefined;
            this.employerId = _data["employerId"];
            this.servCodeAuthType = _data["servCodeAuthType"];
            this.adminAuthSubUtilizationPeriodUnits = _data["adminAuthSubUtilizationPeriodUnits"];
        }
    }

    static fromJS(data: any): InternalAuthorizationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InternalAuthorizationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalAuthorizationId"] = this.internalAuthorizationId;
        data["companyId"] = this.companyId;
        data["serviceCodeId"] = this.serviceCodeId;
        data["serviceCode"] = this.serviceCode;
        data["commentsRequiredValue"] = this.commentsRequiredValue;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["units"] = this.units;
        data["unitsSatisfied"] = this.unitsSatisfied;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["minTransDate"] = this.minTransDate ? this.minTransDate.toISOString() : <any>undefined;
        data["maxTransDate"] = this.maxTransDate ? this.maxTransDate.toISOString() : <any>undefined;
        data["employerId"] = this.employerId;
        data["servCodeAuthType"] = this.servCodeAuthType;
        data["adminAuthSubUtilizationPeriodUnits"] = this.adminAuthSubUtilizationPeriodUnits;
        return data;
    }
}

export interface IInternalAuthorizationResponse {
    internalAuthorizationId?: number;
    companyId?: number;
    serviceCodeId?: number;
    serviceCode?: string | undefined;
    commentsRequiredValue?: number;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    units?: number;
    unitsSatisfied?: number;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    minTransDate?: Date | undefined;
    maxTransDate?: Date | undefined;
    employerId?: number | undefined;
    servCodeAuthType?: number;
    adminAuthSubUtilizationPeriodUnits?: number | undefined;
}

export class InternalAuthorizationResponseList implements IInternalAuthorizationResponseList {
    internalAuthorizationResponses?: InternalAuthorizationResponse[] | undefined;
    caregiverId?: number;

    constructor(data?: IInternalAuthorizationResponseList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["internalAuthorizationResponses"])) {
                this.internalAuthorizationResponses = [] as any;
                for (let item of _data["internalAuthorizationResponses"])
                    this.internalAuthorizationResponses!.push(InternalAuthorizationResponse.fromJS(item));
            }
            this.caregiverId = _data["caregiverId"];
        }
    }

    static fromJS(data: any): InternalAuthorizationResponseList {
        data = typeof data === 'object' ? data : {};
        let result = new InternalAuthorizationResponseList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.internalAuthorizationResponses)) {
            data["internalAuthorizationResponses"] = [];
            for (let item of this.internalAuthorizationResponses)
                data["internalAuthorizationResponses"].push(item.toJSON());
        }
        data["caregiverId"] = this.caregiverId;
        return data;
    }
}

export interface IInternalAuthorizationResponseList {
    internalAuthorizationResponses?: InternalAuthorizationResponse[] | undefined;
    caregiverId?: number;
}

export class InternalAuthorizationUnitsRequest implements IInternalAuthorizationUnitsRequest {
    caregiverId?: string | undefined;
    employerId?: string | undefined;
    serviceCode?: string | undefined;

    constructor(data?: IInternalAuthorizationUnitsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.employerId = _data["employerId"];
            this.serviceCode = _data["serviceCode"];
        }
    }

    static fromJS(data: any): InternalAuthorizationUnitsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InternalAuthorizationUnitsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["employerId"] = this.employerId;
        data["serviceCode"] = this.serviceCode;
        return data;
    }
}

export interface IInternalAuthorizationUnitsRequest {
    caregiverId?: string | undefined;
    employerId?: string | undefined;
    serviceCode?: string | undefined;
}

export class InternalAuthorizationUnitsResponse implements IInternalAuthorizationUnitsResponse {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    unitsRemaining?: number | undefined;

    constructor(data?: IInternalAuthorizationUnitsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.unitsRemaining = _data["unitsRemaining"];
        }
    }

    static fromJS(data: any): InternalAuthorizationUnitsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InternalAuthorizationUnitsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["unitsRemaining"] = this.unitsRemaining;
        return data;
    }
}

export interface IInternalAuthorizationUnitsResponse {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    unitsRemaining?: number | undefined;
}

export class InternalAuthorizationsDeleteDto implements IInternalAuthorizationsDeleteDto {
    internalAuthorizationIds?: number[] | undefined;

    constructor(data?: IInternalAuthorizationsDeleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["internalAuthorizationIds"])) {
                this.internalAuthorizationIds = [] as any;
                for (let item of _data["internalAuthorizationIds"])
                    this.internalAuthorizationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): InternalAuthorizationsDeleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternalAuthorizationsDeleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.internalAuthorizationIds)) {
            data["internalAuthorizationIds"] = [];
            for (let item of this.internalAuthorizationIds)
                data["internalAuthorizationIds"].push(item);
        }
        return data;
    }
}

export interface IInternalAuthorizationsDeleteDto {
    internalAuthorizationIds?: number[] | undefined;
}

export class NoteDto implements INoteDto {
    noteId?: number;
    userName?: string | undefined;
    note?: string | undefined;
    noteDate?: Date;

    constructor(data?: INoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteId = _data["noteId"];
            this.userName = _data["userName"];
            this.note = _data["note"];
            this.noteDate = _data["noteDate"] ? new Date(_data["noteDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteId"] = this.noteId;
        data["userName"] = this.userName;
        data["note"] = this.note;
        data["noteDate"] = this.noteDate ? this.noteDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface INoteDto {
    noteId?: number;
    userName?: string | undefined;
    note?: string | undefined;
    noteDate?: Date;
}

export class ParticipantAuthDetails implements IParticipantAuthDetails {
    authDetailId?: number;
    authHeaderId?: number;
    servCode?: string | undefined;
    displayValue?: string | undefined;
    acn?: string | undefined;
    authStartDate?: Date;
    authEndDate?: Date;
    status?: string | undefined;
    programId?: number;

    constructor(data?: IParticipantAuthDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authDetailId = _data["authDetailId"];
            this.authHeaderId = _data["authHeaderId"];
            this.servCode = _data["servCode"];
            this.displayValue = _data["displayValue"];
            this.acn = _data["acn"];
            this.authStartDate = _data["authStartDate"] ? new Date(_data["authStartDate"].toString()) : <any>undefined;
            this.authEndDate = _data["authEndDate"] ? new Date(_data["authEndDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.programId = _data["programId"];
        }
    }

    static fromJS(data: any): ParticipantAuthDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantAuthDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authDetailId"] = this.authDetailId;
        data["authHeaderId"] = this.authHeaderId;
        data["servCode"] = this.servCode;
        data["displayValue"] = this.displayValue;
        data["acn"] = this.acn;
        data["authStartDate"] = this.authStartDate ? this.authStartDate.toISOString() : <any>undefined;
        data["authEndDate"] = this.authEndDate ? this.authEndDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["programId"] = this.programId;
        return data;
    }
}

export interface IParticipantAuthDetails {
    authDetailId?: number;
    authHeaderId?: number;
    servCode?: string | undefined;
    displayValue?: string | undefined;
    acn?: string | undefined;
    authStartDate?: Date;
    authEndDate?: Date;
    status?: string | undefined;
    programId?: number;
}

export class ParticipantAuthResponse implements IParticipantAuthResponse {
    waiverCode?: string | undefined;
    waiverDescription?: string | undefined;
    externalCaseManager?: string | undefined;
    participantAuthDetails?: ParticipantAuthDetails[] | undefined;

    constructor(data?: IParticipantAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waiverCode = _data["waiverCode"];
            this.waiverDescription = _data["waiverDescription"];
            this.externalCaseManager = _data["externalCaseManager"];
            if (Array.isArray(_data["participantAuthDetails"])) {
                this.participantAuthDetails = [] as any;
                for (let item of _data["participantAuthDetails"])
                    this.participantAuthDetails!.push(ParticipantAuthDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParticipantAuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantAuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waiverCode"] = this.waiverCode;
        data["waiverDescription"] = this.waiverDescription;
        data["externalCaseManager"] = this.externalCaseManager;
        if (Array.isArray(this.participantAuthDetails)) {
            data["participantAuthDetails"] = [];
            for (let item of this.participantAuthDetails)
                data["participantAuthDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IParticipantAuthResponse {
    waiverCode?: string | undefined;
    waiverDescription?: string | undefined;
    externalCaseManager?: string | undefined;
    participantAuthDetails?: ParticipantAuthDetails[] | undefined;
}

export class PayPeriodApiResponse implements IPayPeriodApiResponse {
    payPeriodCount?: number;

    constructor(data?: IPayPeriodApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payPeriodCount = _data["payPeriodCount"];
        }
    }

    static fromJS(data: any): PayPeriodApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PayPeriodApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payPeriodCount"] = this.payPeriodCount;
        return data;
    }
}

export interface IPayPeriodApiResponse {
    payPeriodCount?: number;
}

export class PayPeriodApiResponseApiResponse implements IPayPeriodApiResponseApiResponse {
    message?: string | undefined;
    data?: PayPeriodApiResponse;
    success?: boolean;

    constructor(data?: IPayPeriodApiResponseApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.data = _data["data"] ? PayPeriodApiResponse.fromJS(_data["data"]) : <any>undefined;
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): PayPeriodApiResponseApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PayPeriodApiResponseApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["success"] = this.success;
        return data;
    }
}

export interface IPayPeriodApiResponseApiResponse {
    message?: string | undefined;
    data?: PayPeriodApiResponse;
    success?: boolean;
}

export class PayPeriodRequest implements IPayPeriodRequest {
    serviceStartDate?: Date;
    serviceEndDate?: Date;

    constructor(data?: IPayPeriodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceStartDate = _data["serviceStartDate"] ? new Date(_data["serviceStartDate"].toString()) : <any>undefined;
            this.serviceEndDate = _data["serviceEndDate"] ? new Date(_data["serviceEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PayPeriodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayPeriodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceStartDate"] = this.serviceStartDate ? this.serviceStartDate.toISOString() : <any>undefined;
        data["serviceEndDate"] = this.serviceEndDate ? this.serviceEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayPeriodRequest {
    serviceStartDate?: Date;
    serviceEndDate?: Date;
}

export class PayrollPaidTransactionResult implements IPayrollPaidTransactionResult {
    pcn?: string | undefined;
    tcn?: string | undefined;
    id?: number;
    authSyncStatus?: boolean;
    servCode?: string | undefined;
    serviceDate?: Date;

    constructor(data?: IPayrollPaidTransactionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pcn = _data["pcn"];
            this.tcn = _data["tcn"];
            this.id = _data["id"];
            this.authSyncStatus = _data["authSyncStatus"];
            this.servCode = _data["servCode"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PayrollPaidTransactionResult {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollPaidTransactionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pcn"] = this.pcn;
        data["tcn"] = this.tcn;
        data["id"] = this.id;
        data["authSyncStatus"] = this.authSyncStatus;
        data["servCode"] = this.servCode;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayrollPaidTransactionResult {
    pcn?: string | undefined;
    tcn?: string | undefined;
    id?: number;
    authSyncStatus?: boolean;
    servCode?: string | undefined;
    serviceDate?: Date;
}

export class PostRequestRefreshAuth implements IPostRequestRefreshAuth {
    postRequestRefreshAuthDetailsDto?: PostRequestRefreshAuthDetailsDto[] | undefined;

    constructor(data?: IPostRequestRefreshAuth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["postRequestRefreshAuthDetailsDto"])) {
                this.postRequestRefreshAuthDetailsDto = [] as any;
                for (let item of _data["postRequestRefreshAuthDetailsDto"])
                    this.postRequestRefreshAuthDetailsDto!.push(PostRequestRefreshAuthDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PostRequestRefreshAuth {
        data = typeof data === 'object' ? data : {};
        let result = new PostRequestRefreshAuth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.postRequestRefreshAuthDetailsDto)) {
            data["postRequestRefreshAuthDetailsDto"] = [];
            for (let item of this.postRequestRefreshAuthDetailsDto)
                data["postRequestRefreshAuthDetailsDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPostRequestRefreshAuth {
    postRequestRefreshAuthDetailsDto?: PostRequestRefreshAuthDetailsDto[] | undefined;
}

export class PostRequestRefreshAuthDetailsDto implements IPostRequestRefreshAuthDetailsDto {
    id?: number;
    serviceDate?: Date;
    participantId?: string | undefined;
    servCode?: string | undefined;

    constructor(data?: IPostRequestRefreshAuthDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.participantId = _data["participantId"];
            this.servCode = _data["servCode"];
        }
    }

    static fromJS(data: any): PostRequestRefreshAuthDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostRequestRefreshAuthDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["participantId"] = this.participantId;
        data["servCode"] = this.servCode;
        return data;
    }
}

export interface IPostRequestRefreshAuthDetailsDto {
    id?: number;
    serviceDate?: Date;
    participantId?: string | undefined;
    servCode?: string | undefined;
}

export enum RangeEnum {
    Term = "Term",
    Daily = "Daily",
    Weekly = "Weekly",
    PayPeriod = "PayPeriod",
    Annual = "Annual",
    Monthly = "Monthly",
}

export class RefreshResponseDto implements IRefreshResponseDto {
    id?: number;
    value?: string | undefined;

    constructor(data?: IRefreshResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RefreshResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface IRefreshResponseDto {
    id?: number;
    value?: string | undefined;
}

export class ResponseModel implements IResponseModel {
    isSuccess?: boolean;
    id?: number;
    message?: string | undefined;

    constructor(data?: IResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface IResponseModel {
    isSuccess?: boolean;
    id?: number;
    message?: string | undefined;
}

export class ServCodeLegendRequest implements IServCodeLegendRequest {
    servCodes?: string[] | undefined;
    startDate?: Date;
    endDate?: Date;
    participantPersonId?: string | undefined;

    constructor(data?: IServCodeLegendRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["servCodes"])) {
                this.servCodes = [] as any;
                for (let item of _data["servCodes"])
                    this.servCodes!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.participantPersonId = _data["participantPersonId"];
        }
    }

    static fromJS(data: any): ServCodeLegendRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServCodeLegendRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servCodes)) {
            data["servCodes"] = [];
            for (let item of this.servCodes)
                data["servCodes"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["participantPersonId"] = this.participantPersonId;
        return data;
    }
}

export interface IServCodeLegendRequest {
    servCodes?: string[] | undefined;
    startDate?: Date;
    endDate?: Date;
    participantPersonId?: string | undefined;
}

export class ServCodeLegendResponse implements IServCodeLegendResponse {
    servCode?: string | undefined;
    beginDate?: Date;
    endDate?: Date | undefined;
    unitMulti?: number | undefined;
    docType?: string[] | undefined;
    programId?: number;

    constructor(data?: IServCodeLegendResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servCode = _data["servCode"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.unitMulti = _data["unitMulti"];
            if (Array.isArray(_data["docType"])) {
                this.docType = [] as any;
                for (let item of _data["docType"])
                    this.docType!.push(item);
            }
            this.programId = _data["programId"];
        }
    }

    static fromJS(data: any): ServCodeLegendResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServCodeLegendResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servCode"] = this.servCode;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["unitMulti"] = this.unitMulti;
        if (Array.isArray(this.docType)) {
            data["docType"] = [];
            for (let item of this.docType)
                data["docType"].push(item);
        }
        data["programId"] = this.programId;
        return data;
    }
}

export interface IServCodeLegendResponse {
    servCode?: string | undefined;
    beginDate?: Date;
    endDate?: Date | undefined;
    unitMulti?: number | undefined;
    docType?: string[] | undefined;
    programId?: number;
}

export class ServCodeOwnerRequest implements IServCodeOwnerRequest {
    servCode?: string | undefined;
    servCodeId?: string | undefined;
    ownerType?: string | undefined;
    filterRequest?: FilterRequest;

    constructor(data?: IServCodeOwnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servCode = _data["servCode"];
            this.servCodeId = _data["servCodeId"];
            this.ownerType = _data["ownerType"];
            this.filterRequest = _data["filterRequest"] ? FilterRequest.fromJS(_data["filterRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServCodeOwnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServCodeOwnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servCode"] = this.servCode;
        data["servCodeId"] = this.servCodeId;
        data["ownerType"] = this.ownerType;
        data["filterRequest"] = this.filterRequest ? this.filterRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServCodeOwnerRequest {
    servCode?: string | undefined;
    servCodeId?: string | undefined;
    ownerType?: string | undefined;
    filterRequest?: FilterRequest;
}

export class ServiceAgreementSaveRequest implements IServiceAgreementSaveRequest {
    newACN!: boolean;
    acn?: string | undefined;
    authCode?: string | undefined;
    participantPersonId!: string;
    subAccount?: string | undefined;
    diagCode?: string | undefined;
    status!: AuthorizationDetailsStatus[];
    waiverCodeIdsList?: number[] | undefined;
    waiverCodes?: AuthDetailWaiverCode[] | undefined;
    programNumber?: string | undefined;
    servCode!: string;
    serviceStartDate?: Date;
    serviceEndDate?: Date;
    feePctPr?: number | undefined;
    feePctAdmin?: number | undefined;
    pmFee?: boolean | undefined;
    rangeAmtType?: RangeEnum;
    rangeAmt?: number | undefined;
    rangeUnitType?: RangeEnum;
    rangeUnits?: number | undefined;
    hours?: number | undefined;
    billUnits?: number | undefined;
    budgetAmt?: number | undefined;
    requestedBy!: string;
    requestedDate?: Date | undefined;
    isDraft?: boolean;
    notes?: string | undefined;
    authNotes?: NoteDto[] | undefined;
    ecmExId?: string | undefined;
    externalSysRecordID?: string | undefined;
    serviceType?: string | undefined;
    agreementNumber?: string | undefined;
    externalSysRecordId?: string | undefined;
    autoRenewal?: boolean;

    constructor(data?: IServiceAgreementSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.status = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newACN = _data["newACN"];
            this.acn = _data["acn"];
            this.authCode = _data["authCode"];
            this.participantPersonId = _data["participantPersonId"];
            this.subAccount = _data["subAccount"];
            this.diagCode = _data["diagCode"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            if (Array.isArray(_data["waiverCodeIdsList"])) {
                this.waiverCodeIdsList = [] as any;
                for (let item of _data["waiverCodeIdsList"])
                    this.waiverCodeIdsList!.push(item);
            }
            if (Array.isArray(_data["waiverCodes"])) {
                this.waiverCodes = [] as any;
                for (let item of _data["waiverCodes"])
                    this.waiverCodes!.push(AuthDetailWaiverCode.fromJS(item));
            }
            this.programNumber = _data["programNumber"];
            this.servCode = _data["servCode"];
            this.serviceStartDate = _data["serviceStartDate"] ? new Date(_data["serviceStartDate"].toString()) : <any>undefined;
            this.serviceEndDate = _data["serviceEndDate"] ? new Date(_data["serviceEndDate"].toString()) : <any>undefined;
            this.feePctPr = _data["feePctPr"];
            this.feePctAdmin = _data["feePctAdmin"];
            this.pmFee = _data["pmFee"];
            this.rangeAmtType = _data["rangeAmtType"];
            this.rangeAmt = _data["rangeAmt"];
            this.rangeUnitType = _data["rangeUnitType"];
            this.rangeUnits = _data["rangeUnits"];
            this.hours = _data["hours"];
            this.billUnits = _data["billUnits"];
            this.budgetAmt = _data["budgetAmt"];
            this.requestedBy = _data["requestedBy"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.isDraft = _data["isDraft"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["authNotes"])) {
                this.authNotes = [] as any;
                for (let item of _data["authNotes"])
                    this.authNotes!.push(NoteDto.fromJS(item));
            }
            this.ecmExId = _data["ecmExId"];
            this.externalSysRecordID = _data["externalSysRecordID"];
            this.serviceType = _data["serviceType"];
            this.agreementNumber = _data["agreementNumber"];
            this.externalSysRecordId = _data["externalSysRecordId"];
            this.autoRenewal = _data["autoRenewal"];
        }
    }

    static fromJS(data: any): ServiceAgreementSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAgreementSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newACN"] = this.newACN;
        data["acn"] = this.acn;
        data["authCode"] = this.authCode;
        data["participantPersonId"] = this.participantPersonId;
        data["subAccount"] = this.subAccount;
        data["diagCode"] = this.diagCode;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        if (Array.isArray(this.waiverCodeIdsList)) {
            data["waiverCodeIdsList"] = [];
            for (let item of this.waiverCodeIdsList)
                data["waiverCodeIdsList"].push(item);
        }
        if (Array.isArray(this.waiverCodes)) {
            data["waiverCodes"] = [];
            for (let item of this.waiverCodes)
                data["waiverCodes"].push(item.toJSON());
        }
        data["programNumber"] = this.programNumber;
        data["servCode"] = this.servCode;
        data["serviceStartDate"] = this.serviceStartDate ? this.serviceStartDate.toISOString() : <any>undefined;
        data["serviceEndDate"] = this.serviceEndDate ? this.serviceEndDate.toISOString() : <any>undefined;
        data["feePctPr"] = this.feePctPr;
        data["feePctAdmin"] = this.feePctAdmin;
        data["pmFee"] = this.pmFee;
        data["rangeAmtType"] = this.rangeAmtType;
        data["rangeAmt"] = this.rangeAmt;
        data["rangeUnitType"] = this.rangeUnitType;
        data["rangeUnits"] = this.rangeUnits;
        data["hours"] = this.hours;
        data["billUnits"] = this.billUnits;
        data["budgetAmt"] = this.budgetAmt;
        data["requestedBy"] = this.requestedBy;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["isDraft"] = this.isDraft;
        data["notes"] = this.notes;
        if (Array.isArray(this.authNotes)) {
            data["authNotes"] = [];
            for (let item of this.authNotes)
                data["authNotes"].push(item.toJSON());
        }
        data["ecmExId"] = this.ecmExId;
        data["externalSysRecordID"] = this.externalSysRecordID;
        data["serviceType"] = this.serviceType;
        data["agreementNumber"] = this.agreementNumber;
        data["externalSysRecordId"] = this.externalSysRecordId;
        data["autoRenewal"] = this.autoRenewal;
        return data;
    }
}

export interface IServiceAgreementSaveRequest {
    newACN: boolean;
    acn?: string | undefined;
    authCode?: string | undefined;
    participantPersonId: string;
    subAccount?: string | undefined;
    diagCode?: string | undefined;
    status: AuthorizationDetailsStatus[];
    waiverCodeIdsList?: number[] | undefined;
    waiverCodes?: AuthDetailWaiverCode[] | undefined;
    programNumber?: string | undefined;
    servCode: string;
    serviceStartDate?: Date;
    serviceEndDate?: Date;
    feePctPr?: number | undefined;
    feePctAdmin?: number | undefined;
    pmFee?: boolean | undefined;
    rangeAmtType?: RangeEnum;
    rangeAmt?: number | undefined;
    rangeUnitType?: RangeEnum;
    rangeUnits?: number | undefined;
    hours?: number | undefined;
    billUnits?: number | undefined;
    budgetAmt?: number | undefined;
    requestedBy: string;
    requestedDate?: Date | undefined;
    isDraft?: boolean;
    notes?: string | undefined;
    authNotes?: NoteDto[] | undefined;
    ecmExId?: string | undefined;
    externalSysRecordID?: string | undefined;
    serviceType?: string | undefined;
    agreementNumber?: string | undefined;
    externalSysRecordId?: string | undefined;
    autoRenewal?: boolean;
}

export class ServiceAgreementStatusResponse implements IServiceAgreementStatusResponse {
    key?: string | undefined;
    value?: string | undefined;
    readonly hold?: boolean;

    constructor(data?: IServiceAgreementStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            (<any>this).hold = _data["hold"];
        }
    }

    static fromJS(data: any): ServiceAgreementStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAgreementStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["hold"] = this.hold;
        return data;
    }
}

export interface IServiceAgreementStatusResponse {
    key?: string | undefined;
    value?: string | undefined;
    hold?: boolean;
}

export class ServiceCodeDetailsResponse implements IServiceCodeDetailsResponse {
    id?: number;
    description?: string | undefined;
    displayValue?: string | undefined;
    masterCode?: number | undefined;
    otFlag?: string | undefined;
    okToWorkExemptFlag?: string | undefined;
    cchFlag?: string | undefined;
    wwlFlag?: string | undefined;
    taskRequiredFlag?: string | undefined;
    servCode?: string | undefined;
    status?: string | undefined;
    unitType?: string | undefined;
    payCalculationMethod?: string | undefined;
    masterServCode?: string | undefined;
    masterServCodeDescription?: string | undefined;
    serviceType?: number | undefined;
    serviceTypeCode?: string | undefined;
    serviceTypeDescription?: string | undefined;
    authAllocationFlag?: string | undefined;

    constructor(data?: IServiceCodeDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayValue = _data["displayValue"];
            this.masterCode = _data["masterCode"];
            this.otFlag = _data["otFlag"];
            this.okToWorkExemptFlag = _data["okToWorkExemptFlag"];
            this.cchFlag = _data["cchFlag"];
            this.wwlFlag = _data["wwlFlag"];
            this.taskRequiredFlag = _data["taskRequiredFlag"];
            this.servCode = _data["servCode"];
            this.status = _data["status"];
            this.unitType = _data["unitType"];
            this.payCalculationMethod = _data["payCalculationMethod"];
            this.masterServCode = _data["masterServCode"];
            this.masterServCodeDescription = _data["masterServCodeDescription"];
            this.serviceType = _data["serviceType"];
            this.serviceTypeCode = _data["serviceTypeCode"];
            this.serviceTypeDescription = _data["serviceTypeDescription"];
            this.authAllocationFlag = _data["authAllocationFlag"];
        }
    }

    static fromJS(data: any): ServiceCodeDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayValue"] = this.displayValue;
        data["masterCode"] = this.masterCode;
        data["otFlag"] = this.otFlag;
        data["okToWorkExemptFlag"] = this.okToWorkExemptFlag;
        data["cchFlag"] = this.cchFlag;
        data["wwlFlag"] = this.wwlFlag;
        data["taskRequiredFlag"] = this.taskRequiredFlag;
        data["servCode"] = this.servCode;
        data["status"] = this.status;
        data["unitType"] = this.unitType;
        data["payCalculationMethod"] = this.payCalculationMethod;
        data["masterServCode"] = this.masterServCode;
        data["masterServCodeDescription"] = this.masterServCodeDescription;
        data["serviceType"] = this.serviceType;
        data["serviceTypeCode"] = this.serviceTypeCode;
        data["serviceTypeDescription"] = this.serviceTypeDescription;
        data["authAllocationFlag"] = this.authAllocationFlag;
        return data;
    }
}

export interface IServiceCodeDetailsResponse {
    id?: number;
    description?: string | undefined;
    displayValue?: string | undefined;
    masterCode?: number | undefined;
    otFlag?: string | undefined;
    okToWorkExemptFlag?: string | undefined;
    cchFlag?: string | undefined;
    wwlFlag?: string | undefined;
    taskRequiredFlag?: string | undefined;
    servCode?: string | undefined;
    status?: string | undefined;
    unitType?: string | undefined;
    payCalculationMethod?: string | undefined;
    masterServCode?: string | undefined;
    masterServCodeDescription?: string | undefined;
    serviceType?: number | undefined;
    serviceTypeCode?: string | undefined;
    serviceTypeDescription?: string | undefined;
    authAllocationFlag?: string | undefined;
}

export class ServiceCodeListResponse implements IServiceCodeListResponse {
    serviceCodes?: ServiceCodeResponse[] | undefined;
    weekStartDate?: Date | undefined;

    constructor(data?: IServiceCodeListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceCodes"])) {
                this.serviceCodes = [] as any;
                for (let item of _data["serviceCodes"])
                    this.serviceCodes!.push(ServiceCodeResponse.fromJS(item));
            }
            this.weekStartDate = _data["weekStartDate"] ? new Date(_data["weekStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceCodeListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceCodes)) {
            data["serviceCodes"] = [];
            for (let item of this.serviceCodes)
                data["serviceCodes"].push(item.toJSON());
        }
        data["weekStartDate"] = this.weekStartDate ? this.weekStartDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IServiceCodeListResponse {
    serviceCodes?: ServiceCodeResponse[] | undefined;
    weekStartDate?: Date | undefined;
}

export class ServiceCodeRequest implements IServiceCodeRequest {
    caregiverId?: string | undefined;
    employerUniqueId?: string | undefined;
    startDate?: Date | undefined;
    serviceDate?: Date | undefined;
    isTwoWeek?: boolean;

    constructor(data?: IServiceCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.employerUniqueId = _data["employerUniqueId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.isTwoWeek = _data["isTwoWeek"];
        }
    }

    static fromJS(data: any): ServiceCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["employerUniqueId"] = this.employerUniqueId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["isTwoWeek"] = this.isTwoWeek;
        return data;
    }
}

export interface IServiceCodeRequest {
    caregiverId?: string | undefined;
    employerUniqueId?: string | undefined;
    startDate?: Date | undefined;
    serviceDate?: Date | undefined;
    isTwoWeek?: boolean;
}

export class ServiceCodeResponse implements IServiceCodeResponse {
    serviceCode?: string | undefined;
    serviceCodeDescription?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    okToWorkExempt?: boolean;

    constructor(data?: IServiceCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCode = _data["serviceCode"];
            this.serviceCodeDescription = _data["serviceCodeDescription"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.okToWorkExempt = _data["okToWorkExempt"];
        }
    }

    static fromJS(data: any): ServiceCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCode"] = this.serviceCode;
        data["serviceCodeDescription"] = this.serviceCodeDescription;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["okToWorkExempt"] = this.okToWorkExempt;
        return data;
    }
}

export interface IServiceCodeResponse {
    serviceCode?: string | undefined;
    serviceCodeDescription?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    okToWorkExempt?: boolean;
}

export class ServiceCodeUnitRangeDto implements IServiceCodeUnitRangeDto {
    serviceCodeUnitRangeId?: number | undefined;
    caregiverInternalId?: number;
    employerId?: number;
    serviceCodeId?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    rangeUnits?: number;
    isActive?: boolean;
    updatedBy?:string;
    updatedOn?:Date | undefined;

    constructor(data?: IServiceCodeUnitRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCodeUnitRangeId = _data["serviceCodeUnitRangeId"];
            this.caregiverInternalId = _data["caregiverInternalId"];
            this.employerId = _data["employerId"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.rangeUnits = _data["rangeUnits"];
            this.isActive = _data["isActive"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"];
        }
    }

    static fromJS(data: any): ServiceCodeUnitRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeUnitRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCodeUnitRangeId"] = this.serviceCodeUnitRangeId;
        data["caregiverInternalId"] = this.caregiverInternalId;
        data["employerId"] = this.employerId;
        data["serviceCodeId"] = this.serviceCodeId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["rangeUnits"] = this.rangeUnits;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IServiceCodeUnitRangeDto {
    serviceCodeUnitRangeId?: number | undefined;
    caregiverInternalId?: number;
    employerId?: number;
    serviceCodeId?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    rangeUnits?: number;
    isActive?: boolean;
}

export class ServiceCodeUnitRangeRequest implements IServiceCodeUnitRangeRequest {
    caregiverId?: string | undefined;
    employerId?: string | undefined;

    constructor(data?: IServiceCodeUnitRangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.employerId = _data["employerId"];
        }
    }

    static fromJS(data: any): ServiceCodeUnitRangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeUnitRangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["employerId"] = this.employerId;
        return data;
    }
}

export interface IServiceCodeUnitRangeRequest {
    caregiverId?: string | undefined;
    employerId?: string | undefined;
}

export class ServiceCodeUsageLimitDto implements IServiceCodeUsageLimitDto {
    serviceCodeUsageLimitId?: number;
    personType?: string | undefined;
    serviceCodeId?: number;
    startDate?: Date;
    endDate?: Date;
    maxHours?: number;
    isActive?: boolean;
    authGroupId?: number | undefined;
    relationshipType?: UsageLimitRelationshipType;

    constructor(data?: IServiceCodeUsageLimitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCodeUsageLimitId = _data["serviceCodeUsageLimitId"];
            this.personType = _data["personType"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.maxHours = _data["maxHours"];
            this.isActive = _data["isActive"];
            this.authGroupId = _data["authGroupId"];
            this.relationshipType = _data["relationshipType"];
        }
    }

    static fromJS(data: any): ServiceCodeUsageLimitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeUsageLimitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCodeUsageLimitId"] = this.serviceCodeUsageLimitId;
        data["personType"] = this.personType;
        data["serviceCodeId"] = this.serviceCodeId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["maxHours"] = this.maxHours;
        data["isActive"] = this.isActive;
        data["authGroupId"] = this.authGroupId;
        data["relationshipType"] = this.relationshipType;
        return data;
    }
}

export interface IServiceCodeUsageLimitDto {
    serviceCodeUsageLimitId?: number;
    personType?: string | undefined;
    serviceCodeId?: number;
    startDate?: Date;
    endDate?: Date;
    maxHours?: number;
    isActive?: boolean;
    authGroupId?: number | undefined;
    relationshipType?: UsageLimitRelationshipType;
}

export class StringApiResponse implements IStringApiResponse {
    message?: string | undefined;
    data?: string | undefined;
    success?: boolean;

    constructor(data?: IStringApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.data = _data["data"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): StringApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StringApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["data"] = this.data;
        data["success"] = this.success;
        return data;
    }
}

export interface IStringApiResponse {
    message?: string | undefined;
    data?: string | undefined;
    success?: boolean;
}

export class StringGridResponseBase implements IStringGridResponseBase {
    items?: string[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: string | undefined;

    constructor(data?: IStringGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): StringGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new StringGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data;
        return data;
    }
}

export interface IStringGridResponseBase {
    items?: string[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: string | undefined;
}

export class SubAccountHistoryRequest implements ISubAccountHistoryRequest {
    participantId?: number;

    constructor(data?: ISubAccountHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): SubAccountHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubAccountHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface ISubAccountHistoryRequest {
    participantId?: number;
}

export class SubAccountHistoryResponse implements ISubAccountHistoryResponse {
    subAccount?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: ISubAccountHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subAccount = _data["subAccount"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SubAccountHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubAccountHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subAccount"] = this.subAccount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISubAccountHistoryResponse {
    subAccount?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class SubAccountHistoryResponseGridResponseBase implements ISubAccountHistoryResponseGridResponseBase {
    items?: SubAccountHistoryResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: SubAccountHistoryResponse;

    constructor(data?: ISubAccountHistoryResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubAccountHistoryResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? SubAccountHistoryResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubAccountHistoryResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new SubAccountHistoryResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubAccountHistoryResponseGridResponseBase {
    items?: SubAccountHistoryResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: SubAccountHistoryResponse;
}

export enum UsageLimitRelationshipType {
    None = "None",
    Caregiver = "Caregiver",
    CaregiverEmployer = "CaregiverEmployer",
    Participant = "Participant",
    CaregiverParticipant = "CaregiverParticipant",
}

export class UtilizationSummary implements IUtilizationSummary {
    servCode?: string | undefined;
    agreeNbr?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    unitTotalAuthorized?: number | undefined;
    amtTotalAuthorized?: number | undefined;
    unitTotalUtilized?: number | undefined;
    amtTotalUtilized?: number | undefined;
    unitTotalRemaining?: number | undefined;
    amtTotalRemaining?: number | undefined;

    constructor(data?: IUtilizationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servCode = _data["servCode"];
            this.agreeNbr = _data["agreeNbr"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.unitTotalAuthorized = _data["unitTotalAuthorized"];
            this.amtTotalAuthorized = _data["amtTotalAuthorized"];
            this.unitTotalUtilized = _data["unitTotalUtilized"];
            this.amtTotalUtilized = _data["amtTotalUtilized"];
            this.unitTotalRemaining = _data["unitTotalRemaining"];
            this.amtTotalRemaining = _data["amtTotalRemaining"];
        }
    }

    static fromJS(data: any): UtilizationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new UtilizationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servCode"] = this.servCode;
        data["agreeNbr"] = this.agreeNbr;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["unitTotalAuthorized"] = this.unitTotalAuthorized;
        data["amtTotalAuthorized"] = this.amtTotalAuthorized;
        data["unitTotalUtilized"] = this.unitTotalUtilized;
        data["amtTotalUtilized"] = this.amtTotalUtilized;
        data["unitTotalRemaining"] = this.unitTotalRemaining;
        data["amtTotalRemaining"] = this.amtTotalRemaining;
        return data;
    }
}

export interface IUtilizationSummary {
    servCode?: string | undefined;
    agreeNbr?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    unitTotalAuthorized?: number | undefined;
    amtTotalAuthorized?: number | undefined;
    unitTotalUtilized?: number | undefined;
    amtTotalUtilized?: number | undefined;
    unitTotalRemaining?: number | undefined;
    amtTotalRemaining?: number | undefined;
}

export class WaiverCodeDetails implements IWaiverCodeDetails {
    id?: number;
    waiverCode?: string | undefined;
    waiverName?: string | undefined;
    externalKey?: string | undefined;
    isDeleted?: boolean;
    createdBy?: string | undefined;

    constructor(data?: IWaiverCodeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.waiverCode = _data["waiverCode"];
            this.waiverName = _data["waiverName"];
            this.externalKey = _data["externalKey"];
            this.isDeleted = _data["isDeleted"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): WaiverCodeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new WaiverCodeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["waiverCode"] = this.waiverCode;
        data["waiverName"] = this.waiverName;
        data["externalKey"] = this.externalKey;
        data["isDeleted"] = this.isDeleted;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IWaiverCodeDetails {
    id?: number;
    waiverCode?: string | undefined;
    waiverName?: string | undefined;
    externalKey?: string | undefined;
    isDeleted?: boolean;
    createdBy?: string | undefined;
}

export class WeeklyAllocatableUnits implements IWeeklyAllocatableUnits {
    serviceCode?: string | undefined;
    serviceCodeId?: number | undefined;
    authDetailID?: number | undefined;
    weekStart?: Date;
    weekEnd?: Date;
    allocatableUnits?: number;

    constructor(data?: IWeeklyAllocatableUnits) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCode = _data["serviceCode"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.authDetailID = _data["authDetailID"];
            this.weekStart = _data["weekStart"] ? new Date(_data["weekStart"].toString()) : <any>undefined;
            this.weekEnd = _data["weekEnd"] ? new Date(_data["weekEnd"].toString()) : <any>undefined;
            this.allocatableUnits = _data["allocatableUnits"];
        }
    }

    static fromJS(data: any): WeeklyAllocatableUnits {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyAllocatableUnits();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCode"] = this.serviceCode;
        data["serviceCodeId"] = this.serviceCodeId;
        data["authDetailID"] = this.authDetailID;
        data["weekStart"] = this.weekStart ? this.weekStart.toISOString() : <any>undefined;
        data["weekEnd"] = this.weekEnd ? this.weekEnd.toISOString() : <any>undefined;
        data["allocatableUnits"] = this.allocatableUnits;
        return data;
    }
}

export interface IWeeklyAllocatableUnits {
    serviceCode?: string | undefined;
    serviceCodeId?: number | undefined;
    authDetailID?: number | undefined;
    weekStart?: Date;
    weekEnd?: Date;
    allocatableUnits?: number;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}